import {
  DAYS_OF_TRIAL,
  MIN_LICENSES,
} from "@/helpers/variables/backendConstants";
import { common } from "./common";

export default {
  languages: {
    ptBR: "Português",
    en: "Inglês",
    es: "Español",
  },

  tour: {
    vstep99:
      "Crea tu firma de correo electrónico fácilmente con una plantilla lista y totalmente personalizable.",
    vstep99Title: "Comienza con una plantilla",
    welcome: "Bienvenido a",
    startTour: "Iniciar recorrido",
    skipTour: "Continuar sin recorrido",
  },

  TRIAL: "trial",
  FLEX: "mes",
  ANNUAL: "año",
  TRIENNIAL: "3 años",

  action: {
    export: "Exportar",
    knowPlans: "Quiero conocer los planes",
    talkToTeam: "Hablar con el equipo",
    seePlans: "ver planes",
    cancel: "Cancelar",
    interrupt: "Interrumpir",
    buy: "Comprar",
    confirm: "Confirmar",
    clearFields: "Limpiar campos",
    clear: "Limpiar",
    save: "Guardar",
    saveChanges: "Guardar cambios",
    saveOnly: "Solo guardar",
    saveAndReapply: "Guardar y volver a aplicar",
    reportError: "Reportar error",
    ok: "OK",
    skip: "Saltar",
    continue: "Continuar",
    search: "Buscar",
    knowMore: "Saber más",
    addGroup: "Agregar grupo",
    close: "cerrar",
    delete: "Eliminar",
    edit: "Editar",
    makeDefault: "Establecer como predeterminado",
    next: "Siguiente",
    previous: "Anterior",
    clickingHere: "Haciendo clic aquí",
    saveAndNext: "Guardar y avanzar",
    applyAndNext: "Aplicar y avanzar",
    reloadUserInfo: "Recargar información",
    assignLicense: "Asignar licencia",
    loginGoogle: "Iniciar sesión con Google",
    loginMicrosoft: "Iniciar sesión con Microsoft",
    aboutScopes: "Entender los permisos solicitados",
    installApp: "Instala la aplicación en tu Google Workspace",
    acceptScopes: "Aceptar permisos",
    allowAccess: "Permitir accesos",
    minimize: "Minimizar",
    finish: "Finalizar",
    viewAndSend: "Visualizar y enviar",
    saveAndReapplySignature: "Guardar y volver a aplicar firma",
    sync: "Sincronizar",
    disconnect: "Desconectar",
    create: "Crear",
    new: "Nuevo",
    newWorkspaceGroup: "Nuevo grupo de Workspace",
    transferFilesFromDrive: "Transferir archivos desde Drive",
    migrateEmails: "Migrar correos electrónicos",
    updateUsersViaCSV: "Actualizar usuarios por CSV",
    download: "Descargar",
    clearSelection: "Limpiar selección",
    apply: "Aplicar",
    requestUpdateUsersInfo:
      "Solicitar a los usuarios la actualización de su información",
    requestUsersUpdateInfoAndApply:
      "Solicitar a los usuarios que apliquen la plantilla de firma y actualicen su información",
    calendarsToUsers: "Calendarios a los usuarios",
    removeVacationMessage: "Eliminar mensaje de vacaciones",
    selectAllUsersOnThisPage: "Seleccionar todos los usuarios de esta página",
    send: "Enviar",
    update: "Actualizar",
    preview: "Visualizar",
    transferAndNext: "Transferir y avanzar",
    applyModel: "Aplicar plantilla",
    start: "Comenzar",
    understand: "Entendido",
    reloadShifts: "Recargar turnos",
    createShifts: "Crear turnos",
    applyVacationMessage: "Aplicar mensaje",
    applySignature: "Aplicar firma",
    configVacationMessage: "Configurar vacaciones",
    writeMessage: "Escribir mensaje",
    whatsapp_support: "Atención por WhatsApp",
    syncApps: "Sincronizar aplicaciones",
    verify_number: "Verificar número",
    verify_code: "Validar código",
  },

  common,
  licensing: {
    title: "Licencias por dominio",
    alertTooltip:
      "El uso de la licencia ha superado el límite configurado. Ajuste el límite o elimine licencias de algunos usuarios",
    synchronizingLicenses:
      "<b>Sincronizando licencias</b>: Los datos se están cargando y los números de uso de licencias pueden cambiar hasta que el proceso finalice.",
    unlimitedInputHint:
      "Deje el campo vacío para indicar que no hay límite de uso de licencias por dominio.",
    headers: {
      domain: "Dominio",
      total: "Total",
    },
    activation: {
      title: "Activación",
      description:
        "Active el control de licencias para que Conecta Suite supervise el uso de licencias por dominio. Podrá definir límites de consumo y visualizar con claridad las licencias y el uso en cada dominio.",
      enabled: "Gestión activada",
      disabled: "Gestión desactivada",
    },

    search: {
      label: "Buscar dominios",
    },

    disabledDomainLicensing: {
      title: "La gestión de licencias está desactivada",
      description:
        "Actívala para empezar a configurar los límites por dominio.",
    },

    noData: {
      title: "No se encontraron datos",
      description:
        "Intenta sincronizar para recargar los datos de licencias por dominio.",
    },

    snackars: {
      successSettings: "Configuraciones de licencias actualizadas con éxito.",
      errorSettings: "Error al actualizar las configuraciones de licencias.",
      successUpdateLimit: "Límite de uso de licencias actualizado con éxito.",
      errorUpdateLimit: "Error al actualizar el límite de uso de licencias.",
    },
  },

  scopesDialog: {
    title:
      "Para completar tu inicio de sesión, acepta todos los permisos de Conecta Suite en la Consola de Administración de Google.",
    permissions:
      "Necesitamos estos permisos para ofrecerte una experiencia completa.",
    privacy:
      "Tu privacidad y seguridad son nuestra prioridad, y puedes revisar los permisos en cualquier momento.",
    faq: `Si tienes dudas, accede al <a href="https://conectasuite.com/perguntas-frequentes/escopos-google-workspace/" target="_blank"><b>FAQ</b></a> o contáctanos.`,
    acceptAll: `Accede a la Consola de Administración de Google y haz clic en "Permitir acceso" para continuar.`,
    goToAdminConsole: "Ir a la consola de administración de Google",
    goToPanel: "Ir al panel",
  },

  companyProfile: {
    companyProfile: "Perfil de la Empresa",
    companyInfo: "Información de la empresa",
    companyName: "Nombre de la empresa",
    cnpj: "CNPJ",
    email: "Correo electrónico",
    site: "Sitio web",
    phone: "Teléfono",
    phoneNumber: "Número de teléfono",
    phoneHint:
      "Ingrese un número de teléfono preferentemente con el código de país, área y número.",
    mainPhone: "Teléfono principal",
    corporate: "Razón social",
    financeEmail: "Correo del departamento financiero",
    adminEmail: "Correo del administrador",
    neighborhood: "Barrio",
    address: "Dirección",
    number: "Número",
    complement: "Complemento",
    city: "Ciudad",
    state: "Estado",
    country: "País",
    zipCode: "Código postal",
    partner: "Socio actual",
    partnerCode: "Código del socio",
    uploadLogo: "Cambiar logotipo de la empresa",
    uploadBanner: "Cambiar banner de la empresa",
    language: "Idioma",
    tooltipMessage:
      "Este cambio de idioma se aplicará a todos los usuarios de la empresa y a los correos enviados por la plataforma.",
    completeAddress: "Dirección completa",
    addressExample: "Av. Nombre de ejemplo, 1234",
    addressHint:
      "Consejo: Ingrese la calle completa y el número separado por una coma.",
    reapplyUnavailablePlan:
      "La reaplicación de la firma de correo solo está disponible para los planes Standard +. Contrátalo ahora para utilizarla.",
    reapplyUnavailablePermission:
      "No tienes permiso para gestionar firmas de correo. ¡Solicita al administrador que habilite tu acceso!",
    reapplyDialogTitle:
      "¿Deseas volver a aplicar las plantillas de firma con los nuevos valores?",
    reapplyDialogSubtitle:
      "Los cambios se aplicarán a las plantillas que aparecen a continuación:",
    reapplyHint:
      "<b>Consejo:</b> También puedes gestionar qué plantillas deben ser reaplicadas incluyendo o eliminándolas del campo a continuación:",
    affectedModels: "Plantillas afectadas",
    signatureModelsAlert:
      "Las plantillas de firma pueden tardar hasta 10 minutos en aplicarse completamente.",
    noSignatureModelsAffected:
      "No hay plantillas afectadas por la información modificada.",
    confirmInfoChanges: "¿Confirmar cambios en la información?",
    companyInfoTitle: "Información de la empresa",
    companyInfoSubtitle: "Actualiza y visualiza la información de la empresa.",
    companyContactInfoTitle: "Información de contacto",
    companyContactInfoSubtitle:
      "Actualiza la información de contacto y redes sociales.",
    companyMarketingInfoTitle: "Información de marketing",
    companyMarketingInfoSubtitle: "Configura banner, eslogan y más.",
    companyCustomInfoTitle: "Información personalizada",
    companyCustomInfoSubtitle: "Agrega cualquier información que desees.",
    companyBillingTitle: "Facturación",
    companyBillingSubtitle: "Gestiona tus datos de pago.",
    companyPlansInfoTitle: "Planes y facturación",
    companyPlansInfoSubtitle: "Verifica tu plan e historial de facturación.",
    contactInfo: "Información de contacto y redes sociales",
    companyContactTags: {
      phone2: "Teléfono 2",
      phone3: "Teléfono 3",
      cellphone: "Celular",
      social_media_whatsapp: "WhatsApp",
      social_media_facebook: "Facebook",
      social_media_linkedin: "LinkedIn",
      social_media_twitter: "X (Twitter)",
      social_media_youTube: "YouTube",
      social_media_instagram: "Instagram",
    },
    marketingInfo: "Información de marketing",
    companyMarketingTags: {
      banner_link: "Enlace del banner",
      slogan: "Eslogan",
      trading_name: "Nombre comercial",
    },
    companyMarketingTagsHint: {
      banner_link:
        "Agrega un enlace al cual se redirigirá al hacer clic en el banner.",
    },
    customInfo: "Información personalizada",
    customInfoTooltip:
      "Agrega una información personalizada para usar en tus plantillas de firma",
    addNewInfo: "Agregar nueva información",
    customInfoExceeded: "Se ha superado el límite de información personalizada",
    customInfoTags: {
      company_custom_1: "Información personalizada 1",
      company_custom_2: "Información personalizada 2",
    },
    newCustomTag: "Nueva información personalizada",
    deleteCustomTag: "Eliminar información personalizada",
    confirmDeleteCustomTag:
      "¿Deseas confirmar la eliminación de la información <strong>{tag}</strong>?",
    billingInfo: "Información de facturación",
    billingHistory: "Historial de facturación",
  },

  plansStatus: {
    ACTIVE: "Activo",
    TRIAL: "Trial",
    TRIAL_EXPIRED: "Expirado",
    DISABLED: "Desactivado",
    EXPIRED: "Expirado",
    SUSPENDED: "Suspendido",
    CANCELLED: "Cancelado",
    CANCELLATION_DATE: "Cancelado",
  },

  planPeriodDescription: {
    ANNUAL: "anual",
    TRIENNIAL: "trienal (3 años)",
    FLEX: "mensual",
    QUARTELY: "trimestral",
    SEMESTER: "semestral",
    BIENNIUM: "bienal",
    EXTRA: "licencias extra",
    FREE: "gratuito",
    TRIAL: "trial",
    ONCE: "único",
  },

  companyPlansInfo: {
    myPlans: "Mis planes y servicios",
    knowHowToPurchase: "Descubre cómo contratar un plan para tu empresa",
    licensesNumber: "Número de licencias",
    maxLicensesNumber: "Número máximo de licencias:",
    originalPricePerLicense: "Precio original por licencia",
    originalPrice: "Precio original",
    originalPricePeriod: "Precio original por período:",
    userMonth: "/usuario/mes",
    pricePerLicenseWithDiscount: "Precio por licencia con descuento:",
    priceWithDiscount: "Precio con descuento:",
    totalPrice: "Precio total:",
    installments: "Cuotas:",
    appliedDiscounts: "Descuento aplicado:",
    purchaseDate: "Fecha de contratación:",
    creationDate: "Creación del plan:",
    initBilling: "Inicio de la facturación:",
    endTrial: "Finalización del trial:",
    initTransaction: "Inicio de la factura actual:",
    endTransaction: "Fin de la factura actual:",
    nextBilling: "Próxima facturación:",
    renewalDate: "Renovación del contrato:",
    endDate: "Fecha de finalización:",
    autoRenewal: "Renovación automática",
    paymentMethod: "Método de pago:",
    seePlansDetail: "Ver detalles del plan",
    successEditPlan: "Plan editado con éxito",
    errorEditPlan: "Error al editar el plan",
    createTrialPlan: "Crear plan Trial",
    createTrialPlanConfirmTitle: "Confirmar creación de plan Trial",
    createTrialPlanConfirmMessage:
      "¿Desea confirmar la creación del plan Trial para esta empresa?",
    trialPlanCreatedSuccess: "¡Plan trial creado con éxito!",
    trialPlanCreatedError: "Error al crear el plan trial.",
    trialAlreadyExists: "Esta empresa ya tiene un plan trial.",
    freeTrialPeriod: `Gratis por ${DAYS_OF_TRIAL} días`,
    billingInfo: "Información de facturación",
    savingsOf: "Ahorro de",
    discountApplied: "Descuento aplicado de",
    changePaymentMethod: "Cambiar método de pago",
    paymentChangedTo: "Será cambiado a:",
    disabledAssignment:
      "Asignación de plan deshabilitada. Para habilitarla, el cliente debe instalar la aplicación y realizar el primer acceso para activar el periodo de prueba.",
    disabledServiceAssignment:
      "Asignación de servicio deshabilitada. Para habilitarla, el cliente debe instalar la aplicación y realizar el primer acceso para activar el periodo de prueba.",
  },

  imageUploader: {
    addImage: "Agregar imagen",
    selectImageUrl: "Ingresa una URL",
    selectImageUpload: "sube la imagen",
    selectImage: "Seleccionar imagen",
    selectImageHint: "La imagen se guardará en tu Google Drive",
    imageUrl: "URL de la imagen",
    warningImageSize:
      "tu imagen tiene {size} MB. Para optimizar la carga, ajústala a 2 MB o menos.",
  },

  textFieldRules: {
    requiredCNPJ: "CNPJ es obligatorio",
    insertingCNPJ: "insertando CNPJ...",
    requiredEmail: "Correo electrónico es obligatorio",
    invalidEmail: "Correo electrónico inválido",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    mustContainCapitalLetters: "Debe contener letras mayúsculas",
    mustContainLowercaselLetters: "Debe contener letras minúsculas",
    mustContainsNumbers: "Debe contener números",
    mustContainSpecialCharacters: "Debe contener caracteres especiales",
    requiredField: "Campo obligatorio",
    minCharacters: "Número mínimo de caracteres",
    maxCharacters: "Número máximo de caracteres",
    imageTooLarge: "Imagen demasiado grande",
    maxXCharacters: "Máximo de {number} caracteres",
    max20characters: "Máximo de 20 caracteres",
    max25characters: "Máximo de 25 caracteres",
    max60characters: "Máximo de 60 caracteres",
    max120characters: "Máximo de 120 caracteres",
    max1490characters: "El valor no puede tener más de 1490 caracteres",
    specialCharacters: "El campo no puede contener caracteres especiales",
    noSpaceCharacters: "El campo no puede contener solo espacios",
    fieldLessThan: "El campo debe ser menor que",
    cannotContainOnlySpaces: "El campo no puede contener solo espacios",
    typeValidPhone: "Por favor, introduce un número de teléfono válido",
    requiredFullName: "¡Introduce tu nombre completo!",
    selectAnOption: "¡Selecciona una opción!",
    enterValidPhone: "¡Ingresa un número válido!",
    selectOneItem: "¡Selecciona al menos 1 ítem para continuar!",
  },

  navbar: {},

  sidebar: {
    home: "Inicio",
    install: "Instalar extensión",
    techDiagnosis: "Diagnóstico técnico",
    patnerPanel: "Panel del socio",
    clients: "Clientes",
    billing: "Facturación",
    plans: "Planes",
    services: "Servicios",
    notificationCenter: "Centro de notificaciones",
    clientsBans: "Clientes bloqueados",
    toManage: "Gestionar",
    onboardingUser: "Crear usuario",
    company: "Empresa",
    profile: "Perfil",
    inventory: "Inventario digital",
    reports: "Informes",
    licensing: "Licenciamiento",
    general: "Generales",
    accounts: "Cuentas de usuario",
    permissions: "Permisos",
    emailSignatures: "Firmas de correo",
    vacationMessages: "Mensajes de vacaciones",
    signAutomation: "Aplicación automática",
    control: "Control",
    conectaControl: "Conecta Control",
    hirePlan: "Contratar un plan",
    offboardingUser: "Eliminar usuario",
    vacationMessage: "Mensaje de vacaciones",
    assignVacationMode: "Asignar modo vacaciones",

    createUser: "Crear usuario",
    removeUser: "Eliminar usuario",
    migration: "Migración",
    feedbackGroupCTA: "¡Únete ahora!",
    vacation: "Vacaciones",
    controlShifts: "Turnos de trabajo",
    realeaseTemporaryAccess: "Liberar acceso temporal",
    accessReport: "Informes de acceso",

    basic: "¡Accede a más herramientas con el Plan Security!",
    standard: "¡Accede a más herramientas con el Plan Security!",
    security: "¡Accede a más herramientas con el Plan Enterprise!",
    enterprise:
      "¡Únete a nuestro grupo de usuarios que brindan feedback y obtén ventajas exclusivas!",

    mustInstall: "Instala la aplicación para utilizar esta función.",
  },

  hirePlan: {
    economyOf: "Ahorro de ",
    paymentPlan: "Plan de pago",
    paymentMinimumValue: "¡El valor mínimo de compra de R$40 no fue alcanzado!",
    decreaseLicenseRule:
      "El número de licencias no puede ser inferior al número de usuarios de la empresa",
    paymentMinimumValueTextforFlex:
      "Selecciona el plan de pago anual para continuar",
    paymentMinimumValueTextforAnnual:
      "Agrega licencias extra para continuar con esta modalidad.",
    goBackToPlans: "Volver a los planes",
    goBackToHome: "Volver al inicio",
    annualPayment: "Pago anual",
    monthlyPayment: "Pago mensual",
  },

  billing: {
    initBilling: "Inicio de la facturación",
    discountOf: "Descuento de",
    fromOriginalPrice: "del precio original",
    goToSuperLogica: "Ir a SuperLógica",
  },

  selfCheckout: {
    minLicensesInfo: `Para asegurar la calidad de los servicios ofrecidos y la eficiencia del soporte al cliente, Conecta Suite establece la obligatoriedad de contratar un mínimo de ${MIN_LICENSES} licencias.`,
    oneTimeCharge: "Cargo único",
    agileImplementation: "Implementación Ágil",
    checkServiceDescription:
      "Consulta lo que ofrece la Implementación Ágil {name}.",
    standardImplementationHint:
      "Implementación de dos firmas de correo electrónico personalizadas con la identidad de tu empresa.",
    securityImplementationHint:
      "Con la implementación ágil, realizaremos un recorrido por las herramientas de Conecta Suite, explicaremos detalles importantes para el uso optimizado de Conecta Control, cómo funcionan los bloqueos y los informes de análisis. Además, el equipo de Conecta creará dos firmas personalizadas con la identidad de tu empresa.",
    implementServiceContact: "Contacto para implementación del servicio",
    implementServiceContactDescription:
      "Nuestro equipo se pondrá en contacto para realizar la implementación ágil de Conecta Suite. Si lo prefieres, contáctanos por email a <strong>implementacao@conectasuite.com</strong>",
    implementService: "de servicio de implementación",
    cart: "Carrito",
    licensesTipForAnnual:
      "Define el número de licencias adicionales para contratar el plan anual. El mínimo corresponde al número de usuarios de tu Google Workspace.",
    creditCardPaymentInstructions:
      "paga con tarjeta de crédito a través de Superlógica",
    bankSlip: "Boleto bancario",
    bankSlipPaymentTitle: "¡Contratación realizada!",
    receiveBankSlipEmail: "Recibe el boleto para pago vía correo electrónico",
    orderDetails: "Detalles del pedido",
    bankSlipDueDate: "Fecha de vencimiento del boleto",
    paymentType: "Forma de pago",
    creditCard: "Tarjeta de crédito",
    finishBuy: "Finalizar compra",
    clearCart: "Vaciar carrito",
    removePlanFromCart: "Eliminar plan del carrito",
    confirmPlanPurchaseText: "Sí, contratar este plan",
    implemantationHelp:
      "Quiero ayuda del equipo de Conecta Suite para implementar",
    goToPayment: "Ir al pago",
    confirmNewPlan: "Confirmar nuevo plan",
    overwriteCurrentPlan:
      "Ya tienes uno o más productos del plan que deseas contratar. Al continuar, aceptas desactivar el plan actual y activar el nuevo.",
    newPlan: "Nuevo plan",
    overwriteCurrentPlanAlert:
      "Algunos productos de tu plan actual no están incluidos en el nuevo. ¿Deseas desactivar el plan actual y contratar el nuevo?",
    trialEnded: "Tu período de prueba ha terminado",
    trialEndedText:
      "Adquiere un plan para seguir aprovechando todas las funcionalidades de Conecta Suite",
    getBasicAfterTrialEnded: "Después del fin de la prueba (a partir de",
    simulationAlert:
      "Por motivos de seguridad, no se permite contratar planes durante una simulación de inicio de sesión. <br /> Pide a un administrador de Google que realice la operación desde esta pantalla o desde el panel del cliente.",
    notApplicable: "No aplica",
    helpCardFeatureListTitle1:
      "Accede a SuperLogica y realiza el pago en la plataforma",
    helpCardFeatureListSubtitle1:
      "Tu cuenta en SuperLogica fue creada. ¡Usa tu correo para acceder! Los datos proporcionados se usarán para la facturación.",
    helpCardFeatureListTitle2: `Pronto recibirás un correo para realizar el pago con tarjeta de crédito.`,
    helpCardFeatureListSubtitle2: `Si no fuiste redirigido, <a href="https://brlgestao.superlogica.net/clients/areadocliente/clientes/formadepagamento" target="_blank">haz clic aquí</a>.`,
    helpCardFeatureListTitle3: `¡No te preocupes! Te enviaremos un correo confirmando cuando recibamos tu pago.`,
    helpCardFeatureListSubtitle3: `Por tu seguridad, no almacenamos los datos de tu tarjeta en nuestra base de datos ni en ningún lugar de la aplicación.`,

    helpBankSlipFeatureListTitle1:
      "La información de contratación será enviada a los correos registrados.",
    helpBankSlipFeatureListSubtitle1:
      "El correo contiene información importante sobre el plan, forma de pago, valor por licencia y fecha de inicio de facturación.",
    helpBankSlipFeatureListTitle2: `Pronto recibirás un correo con el boleto para realizar el pago.`,
    helpBankSlipFeatureListSubtitle2: `El boleto también estará disponible en SuperLogica. Puedes acceder al área del cliente <a href="https://brlgestao.superlogica.net/clients/areadocliente/clientes/formadepagamento" target="_blank">haciendo clic aquí</a>.`,
    helpBankSlipFeatureListTitle3:
      "¡Ya tienes acceso a las herramientas! Siéntete libre de usarlas.",
    helpBankSlipFeatureListSubtitle3: "",

    hirePlanSnackbarPrefix: "El plan ",
    hirePlanSnackbarSuffix:
      " fue contratado con éxito. Se enviará un correo de confirmación desde",
    hireBasicPlanRule:
      "Este plan estará disponible después del fin del período de prueba.",
    choosePlanPaymentType: "Elige el tipo de pago:",
    trialPeriod: "Período de prueba",
    beingRedirectdToSL: "Serás redirigido a SuperLogica en",
    requestChangeSuccess:
      "Solicitud enviada con éxito. El equipo de Conecta Suite ha sido notificado y dará seguimiento al proceso.",
    requestChangeError: "Error al enviar la solicitud. Inténtalo de nuevo.",
    feedbackRegisterError:
      "Error al registrar la evaluación, por favor inténtalo de nuevo",
    confirmPlanChangeTitle: "Confirmar solicitud de cambio",
    confirmPlanChangeDefault: `<div class="mt-5">
                <p><b>¡Atención!</b> Hemos identificado que usted está solicitando un cambio en su plan.</p>

              <p>
                Según lo establecido en nuestros
                <a
                  href="https://conectasuite.com/termos-de-uso/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Términos de Uso</a
                >, este tipo de cambio requiere un
                <b>aviso previo de 30 días.</b>
              </p>

              <p>
                Para garantizar una mejor atención, nuestro equipo de Éxito del Cliente se pondrá en contacto con usted en un plazo de hasta
                <b>2 días hábiles</b> para continuar con el proceso y aclarar cualquier duda.
              </p>

              <p>
               No se aplicará ningún cambio de forma automática en la plataforma. Si lo prefiere, también puede contactarnos directamente a través del correo
                <b>sucesso@conectasuite.com</b>.
              </p>

              <p><b>¡Gracias por su comprensión!</b></p>
              </div>`,
    helpWithPaymentText: "¿Tienes dudas sobre el pago o los planes?",
    accessPageSuportText: `Envía un correo a <a href="mailto:financeiro@conectasuite.com" target="_blank">financeiro@conectasuite.com</a> o consulta nuestra página de soporte.`,
    almostThere: "¡Ya casi terminas!",

    plansDescriptions: {
      basic: {
        availability: "Disponible para Google Workspace (G Suite)",
        individualSignatures:
          "Crea, edita y aplica firmas HTML de forma individual para los usuarios",
        absenceManagement:
          "Gestiona mensajes de vacaciones, feriados y ausencias por usuario",
        groupManagement:
          "Agrega usuarios a grupos de correo, calendarios y drives compartidos",
        externalEmail:
          "Permite que tus colaboradores envíen y reciban correos desde otras direcciones",
        delegatedManagement:
          "Delegación de permisos de gestión para otros usuarios desde el panel de Conecta Suite",
        adminReport:
          "Informe detallado con puntos de mejora del panel de Google Workspace Admin",
        userSetup:
          "Registro y configuración simplificada de nuevos usuarios (nuevos empleados)",
        accessSuspension: "Suspensión de accesos de usuarios (ex-empleados)",
      },
      standard: {
        availability:
          "Disponible para Google Workspace (G Suite) y Microsoft 365",
        basicBenefits: "Beneficios del plan Basic",
        bulkSignatures: "Gestión masiva de firmas vía editor avanzado",
        createSignatureTemplates:
          "Crea una galería ilimitada de plantillas de firma para tu empresa",
        scheduledUpdates: "Programa cambios en firmas para fechas especiales",
        absenceSignatures:
          "Crea y gestiona firmas de mensajes de ausencia masivamente o individualmente",
        signatureTemplates: "Accede a plantillas listas de firmas",
        connectedApps:
          "Informe de apps conectadas al correo corporativo de los usuarios",
        delegationExpiration:
          "Define expiración de delegación de acceso al buzón de correo",
      },
      security: {
        availability:
          "Disponible para Google Workspace (G Suite) y Microsoft 365",
        basicBenefits: "Beneficios del plan Basic",
        standardBenefits: "Beneficios del plan Standard",
        autoReapply: "Reaplicación automática de firmas",
        accessControl:
          "Restringe el acceso de colaboradores por horario, sistema, navegador, DNS, VPN e IP",
        customShifts:
          "Crea reglas de acceso con turnos personalizados ilimitados",
        deviceDisconnect:
          "Desconecta al colaborador automáticamente o con un clic al finalizar el turno",
        licenseDeactivation: "Desactivación de licencias (ex-empleados)",
        loginReport: "Informe de accesos de correo (login/logout)",
        fileSharingReport: "Informe de archivos compartidos corporativos",
        customLogin: "Pantalla de login personalizada con identidad visual",
        migrationBackup:
          "Migra correos y archivos entre cuentas y grupos para respaldo",
      },
      enterprise: {
        availability:
          "Disponible para Google Workspace (G Suite) y Microsoft 365",
        basicBenefits: "Beneficios del plan Basic",
        standardBenefits: "Beneficios del plan Standard",
        securityBenefits: "Beneficios del plan Security",
        seniorIntegration: "Integración con Senior Sistemas",
        vrGenteIntegration: "Integración con VR Gente (Pontomais)",
        activeDirectory: "Integración con Active Directory (AD)",
        tangerinoIntegration: "Integración con Sólides Tangerino",
        otherIntegrations: "Otras integraciones disponibles",
      },
    },

    serviceDescriptions: {
      standard: {
        adjustmentsAndGoodPractices: "Ajustes y buenas prácticas",
        adjustmentsUsers: "Ajustes de usuarios en Workspace y Conecta Suite",
        signatureConfig: "Configuración para aplicar firmas y delegaciones",
        goodPracticesEmail: "Buenas prácticas de correo y firmas",
        spamOrientation: "Validaciones y consejos para evitar SPAM",
        infoSecurity: "Buenas prácticas de seguridad de la información",
        workspaceTraining:
          "Orientación para crear grupos de correo en Google Workspace",
        signatures: "Firmas de correo electrónico",
        signatureModels: "Creación de 2 modelos de firma personalizados",
        applyInBatch: "Aplicación de la primera firma en todos los usuarios",
        training: "Capacitación",
        trainingManagers:
          "Capacitación para gestores de la plataforma Conecta Suite para un mejor aprovechamiento.",
      },
      security: {
        controlAccessConfig: "Configuración y activación de control de acceso",
        shifts: "Definición y configuración de turnos",
        controlActivation: "Configuración y activación de Conecta Control",
        enterpriseIntegrations: "Integraciones - Conecta Suite Enterprise",
        adIntegration: "Configuración y activación de AD Integration",
        sistemIntegration: "Integración con sistema de registro de asistencia",
      },
    },

    confirmingNewPlan: {
      youAreAboutToLose: "Al cambiar de plan perderás:",
      wantBenefits: "Quiero conservar mis beneficios",
      dontWantBenefits: "Entiendo y no quiero conservar mis beneficios",
      beforeContinuing: "Antes de continuar...",
      howDoYouRate: "¿Cómo calificas tu plan actual?",
      tellUsTheReason: "Cuéntanos por qué deseas cancelar tu plan.",
    },

    churnReasons: {
      tooExpensive: "Muy caro: El costo es demasiado alto.",
      notUsed: "No lo uso: Estoy pagando por funciones que no utilizo.",
      foundCheaper: "Competencia: Encontré una opción más económica.",
      foundBetter: "Competencia: Encontré una opción mejor.",
      noLongerNeeded: "Ya no lo necesito: No requiero el servicio.",
      difficultToUse: "Mala experiencia: Difícil de usar o administrar.",
      billingProblems: "Cobros: Problemas con facturación o pagos.",
      notConfident: "Seguridad: No confío en las funciones de seguridad.",
      lackOfIntegrations: "Integraciones: Necesito más integraciones.",
      otherReason: "Otro motivo:",
    },

    annualDowngradeBlock:
      "No se puede hacer downgrade en el plan anual. Por favor, contáctanos vía email a experience@conectasuite.com.",
    triennialDowngradeBlock:
      "No es posible cambiar el plan en la modalidad trienal. Por favor, contáctanos por correo electrónico a experience@conectasuite.com.",
    subscriptionTypeChangeBlock:
      "No se permite cambiar la periodicidad del plan.",
  },

  purchaseLoading: {
    savingPlanInfo: "Guardando la información de tu nuevo plan...",
    youBeeingRedirected: "Serás redirigido(a) para completar el pago...",
    redirectingIn: "Serás redirigido en ",
  },

  companyInformation: {
    missingCNPJAlert:
      "Esta empresa <b>no tiene CNPJ registrado</b>. Para continuar con la compra es necesario completar la información obligatoria.",
    billingInfo: "Información de facturación",
  },

  advicePermissionDialog: {
    companyInfoTitle: "Sin permiso de acceso",
    companyInfoMessage:
      "No tienes permiso para acceder al Perfil de la Empresa. Solicita a un administrador que complete el registro de la empresa antes de finalizar un plan.",
  },

  companyProfileForm: {
    saveAndReaply:
      "Guardar los cambios y volver a aplicar las firmas con la información actualizada",
    saveWithoutReapply: "Guardar los cambios sin volver a aplicar las firmas",
  },

  comparativePlan: {},

  periodicity: {
    monthly: "Mensual",
    annual: "Anual",
    ANNUAL: "anual",
    FLEX: "mensual",
    month: "mes",
    year: "año",
    annualPayment: "Anual (Pago anual)",
  },

  errorMessages: {
    registerPlan: "¡Ups! Error al registrar la información del plan",
    totalCalc: "Error al calcular el valor total",
    updateCompanyData: "Error al actualizar la información de la empresa",
    fillingRequiredFields: "Completa los campos obligatorios",
    USER_GOOGLE_ADMIN: "El usuario es un administrador de Google.",
    USER_ALREADY_SUSPENDED: "El usuario ya está suspendido",
    USER_ALREADY_ACTIVE: "El usuario ya está activo",
    setSignatureToUsers:
      "No fue posible aplicar los cambios de firma. Intenta nuevamente.",
    FREE_USAGE_LIMIT_EXCEEDED:
      "Se ha alcanzado el límite de uso gratuito. Es necesario contratar un plan para continuar utilizando esta funcionalidad.",
    requestSent: "Error al enviar la solicitud",
    signatureEmailSent: "Error al enviar el correo electrónico",
    updateTags: "Error al actualizar la información",
    photoLink: "La imagen no tiene acceso público o el enlace es inválido.",
    BAD_REQUEST:
      "No fue posible completar la operación. Intenta nuevamente en un minuto.",
    CONFLICT: "Hay una acción en proceso. Intenta nuevamente en un minuto.",
    INVALID_PASSWORD:
      "Esta contraseña no se puede usar. Elige otra y vuelve a intentarlo.",
    GROUP_NOT_FOUND:
      "No se encontró el grupo. Verifica si el nombre es correcto o si ya fue creado en Google Workspace.",
    MAIL_SERVICE_NOT_ENABLED:
      "No fue posible migrar los correos porque la licencia del usuario fue removida.",
    USER_NOT_FOUND:
      "No se encontró al usuario. Verifica que el correo esté correcto o que el usuario exista en Google Workspace.",
    INVALID_GOOGLE_ACCESS_TOKEN: `Token inválido. Verifique los permisos en el <a href='https://admin.google.com/ac/apps/gmail/marketplace/appdetails/${process.env.VUE_APP_MARKETPLACE_APP_ID}' target='_blank'>Google Admin Console</a>.</br>Google puede tardar hasta 24 horas en procesar los permisos.`,
  },

  successMessages: {
    dataUpdated: "Datos actualizados correctamente",
    setSignatureToUsers:
      "Las firmas de correo de los usuarios seleccionados serán actualizadas en breve.",
    scheduleSignature:
      "La programación fue hecha para: {date}. Revisa los agendamientos en 'Aplicación automática'.",
    requestSent: "¡Solicitud enviada con éxito!",
    signatureEmailSent: "¡Correo con la firma enviado con éxito!",
    templateApplied: "¡Operación realizada con éxito!",
  },

  techDiagnosis: {
    title: "Diagnóstico Tech",

    sessions: {
      generalInfo: "Información general",
      economyInfo: "Ahorro",
      emails: "Correos electrónicos",
      security: "Seguridad",
    },

    fillResearchValues:
      "Completa los datos sobre Google Workspace para verificar valores.",
    goToGoogleWorkspace: "Acceder a Google Workspace",
    chatSupport: "Soporte",
    analyzingCompany: "Estamos analizando tu empresa.",
    companyInOrder: "Tu empresa está en orden.",
    companyHasPointsOfImprovement:
      "Identificamos puntos de mejora para tu empresa.",
    companyHasPointsOfAttention:
      "Identificamos puntos de atención para tu empresa.",
    getAnAnalysis: "Recibe un análisis de tu empresa.",
    kindUsers: "usuarios",
    kindUser: "usuario",
    kindUsersWithLicense: "usuarios con licencia",
    kindUserWithLicense: "usuario con licencia",
    totalPrice: "Total: R$ {price} mensuales",
    totalPriceTooltip:
      "Identificamos que tu empresa podría tener un costo innecesario de hasta R${price} mensuales.",

    workspaceResearch: {
      almostThere: "Ya casi...",
      answerQuestionsBellow:
        "Para un mejor diagnóstico, responde las siguientes preguntas:",
      partnerMethodLabel: "Tu contratación de Google Workspace es:",
      renewalDateLabel: "¿Cuál es la fecha de renovación del contrato vigente?",
      priceLicenseLabel: "¿Cuál es el valor por licencia? (R$ usuario/mes)",
      directWithGoogle: "Directamente con Google",
      authorizedPartner: "A través de Partner Autorizado",
      ruleMaxValue: "El valor no puede ser mayor que 1000.",
      ruleMinValue: "Introduce un valor válido.",
    },

    workspaceInfo: {
      title: "Google Workspace",
      missingData:
        "Datos no proporcionados: Completa los datos de Google Workspace para recibir un diagnóstico adecuado.",
      editData: "Editar datos",
      fillData: "Completar datos",
      goToGoogleAdmin: "Ir al panel de Google Workspace",
      partnerMethod: "Forma de contratación: ",
      renewalDate: "Fecha de renovación: ",
      activeLicenses: "Licencias activas: ",
      pricePerLicense: "Valor por licencia: ",
      priceResult: "R${price} usuario/mes",
    },

    usersGraphics: {
      title: "Gráfico de usuarios",
      inactiveWithoutLicense: "Inactivos sin licencia",
      inactiveWithActiveLicense: "Inactivos con licencia",
      suspendedWithoutLicense: "Suspendidos sin licencia",
      suspendedWithActiveLicense: "Suspendidos con licencia",
      active: "Activos",
      individual: "Individuales",
      couldBeGroups: "Podrían ser grupos",
    },

    alertInfoOnlyActiveLicense:
      "Solo los usuarios con licencia de correo electrónico activa se incluyen en los cálculos. {userCategory} sin esta licencia no afectan los costos presentados.",

    generalRow: {
      totalPrice: "R$ {price} mensuales",
      totalPriceText:
        "Identificamos que tu empresa podría estar incurriendo en un costo innecesario de hasta R${price} mensuales en esta categoría.",
      withoutResearchPriceText:
        "Basado en los valores del plan Business Plus de Google Workspace, tu empresa podría tener un costo innecesario de hasta R${price} mensuales en esta categoría. Completa el valor de la licencia al lado para obtener un diagnóstico adecuado.",
      neverLogged: "Nunca inició sesión",
      usersKind: "Usuarios",
    },

    inactiveUsers: {
      title: "Usuarios inactivos",
      tooltipText:
        "Hay usuarios inactivos en tu Workspace, lo cual puede estar generando un costo innecesario para tu empresa. {researchAlert}",
      inactiveDays: "inactivos por más de {numberOfDays} días",
    },

    suspendedUsers: {
      title: "Usuarios suspendidos",
      tooltipText:
        "Hay usuarios suspendidos en tu Workspace, lo cual puede estar generando un costo innecesario para tu empresa. {researchAlert}",
    },

    couldBeGroupsUsers: {
      title: "Usuarios que podrían ser grupos",
      tooltipText:
        "Identificamos usuarios que podrían ser grupos para optimizar tus costos. Al utilizar grupos, puedes beneficiarte de correo gratuito y otras ventajas de organización, además de seguir las buenas prácticas de Google. Para más información, contacta con nuestro soporte.",
    },

    inactiveAppsUsers: {
      title: "Aplicaciones de usuarios inactivos",
      tooltipText:
        "Identificamos usuarios inactivos que mantienen conexiones con aplicaciones externas. Esto puede representar costos adicionales o riesgos de seguridad para tu empresa. Accede a tu inventario para más información.",
      app: "Aplicación",
      apps: "Aplicaciones",
      accessInventory: "Accede a tu inventario",
    },

    withoutSignatureUsers: {
      title: "Usuarios sin firma de correo",
      tooltipText:
        "¡Hay colaboradores sin firmas! Utiliza ahora firmas profesionales de correo de Conecta Suite para mantener los datos y la identidad de tu marca siempre actualizados.",
      goToSignature: "Ir a firmas",
    },

    DNS: {
      title: "Calidad de los dominios",
      tooltipText:
        "¡Algunos dominios necesitan tu atención! Verifica los registros MX, SPF y DKIM de tus dominios. En caso de dudas, contáctanos a través de nuestro soporte.",
      domains: "dominios",
      domain: "Dominio",
      knowMore: "Para saber más sobre MX, SPF y DKIM de dominios: ",
      FAQ: "consulta nuestro FAQ",
      chatSupport: "En caso de dudas, contáctanos a través del soporte.",
      helpArticle: "Ver artículo de ayuda",
      selector: "Selector",
      editSelector: "Editar selector",
      selectorInfo:
        "El selector DKIM es un identificador único para un dominio que utiliza DKIM.",
      spamVerify: "Verificar si el dominio está en alguna lista negra de spam",
      useThe: "Utiliza el",
      seeOur: "Consulta nuestro",
      knowMoreBlackLists:
        "para saber más sobre listas negras de spam y cómo proteger tu dominio en Google Workspace.",
      knowMoreDomains:
        "Para saber más sobre la información de tu dominio, consulta el",
      ignoredDomainText:
        "La verificación de calidad fue ignorada automáticamente para este dominio ya que no realiza envíos de correos.",
      ignoredVerify: "Verificación ignorada",
      mxRecordsNotFound:
        "El dominio necesita tener al menos un servidor de correo configurado.",
      priorityMxRecordFound:
        "Dominio configurado con el servidor de correo de mayor prioridad",
      allMxRecordsConfigured: "Todos los registros MX están configurados",
      missingMxRecords: "Faltan algunos registros MX",
      googleStandardSpf: "SPF sigue el estándar de Google",
      microsoftStandardSpf: "SPF sigue el estándar de Microsoft",
      googleSpfNonStandard: "El SPF configurado no sigue el estándar de Google",
      microsoftSpfNonStandard:
        "El SPF configurado no sigue el estándar de Microsoft",
      missingSpfDnsTxt: "¡SPF no configurado!",
      foundDkim: "DKIM configurado",
      missingDkim: "DKIM no configurado",
      missingDomainData:
        "No se pudo encontrar una IP de servidor de nombres que muestre este dominio.",
      alertMessages: {
        BAD: "Se detectaron problemas críticos en la configuración de este dominio.",
        WARNING:
          "Se detectaron problemas no críticos en la configuración de este dominio.",
        OK: "La configuración de dominio, MX, SPF y DKIM se realizó con éxito.",
      },
    },

    without2faUsers: {
      title: "Usuarios sin autenticación de dos factores",
      tooltipText:
        "La seguridad de las cuentas de tus colaboradores puede mejorarse activando la autenticación de dos factores (2FA). Esta medida es esencial para proteger los datos de tu empresa, agregando una capa adicional de seguridad. Te recomendamos activar la 2FA desde las configuraciones de seguridad del Workspace.",
    },

    googleDriveReports: {
      title: "Archivos y carpetas de Google Drive",
      tooltipText:
        "Los archivos y carpetas de tu Drive corporativo pueden estar siendo compartidos externamente. Te recomendamos revisar el informe correspondiente para garantizar el control total de tus datos.",
      files: "Archivos",
    },

    googleTakeout: {
      title: "Garantiza la protección de los datos corporativos",
      tooltipText:
        "Tus usuarios pueden tener acceso a Google Takeout y exportar datos sensibles de tu empresa. ¡Revisa tu configuración de seguridad!",
      knowHowToVerify: "Saber cómo verificar aquí",
    },

    privacyCheckup: {
      title: "Asegura tu privacidad",
      tooltipText:
        "Revisa tus configuraciones clave de privacidad según los servicios de Google que más utilizas.",
      knowHowToVerify: "Revisa haciendo clic aquí",
    },
  },

  onboardingNewUser: {
    welcomeOnboardingTitle: "Bienvenido a la creación de usuario",
    welcomeOnboardingSubtitle: "Antes de comenzar debes saber",
    totalStepsLabel: "Este es un proceso de 7 pasos.",
    progressAutomaticSaveLabel:
      "Puedes pausar este proceso en cualquier momento y tu progreso será guardado.",
    requiredFirstStepLabel:
      "El primer paso es obligatorio para que los siguientes puedan ejecutarse.",
    suportHelperLabel:
      "Si tienes dudas, puedes contactar a nuestro soporte por los canales de atención.",
    recommendedDeviceLabel:
      "Para optimizar tu productividad y rendimiento, te recomendamos usar una computadora de escritorio para este flujo.",
    userProfilePhoto: "Foto de perfil del usuario",

    selectLicenses: "Seleccionar licencias",
    userLicenses: "Licencias de este usuario",
    userLicensesDescription:
      "Selecciona las licencias que este usuario debe recibir. El límite de cada licencia se configura por dominio.",
    licenseAssignedAutomaticallyByGoogle:
      "Esta licencia se asigna automáticamente por Google",
    noLicensesAvailable: "No hay licencias disponibles para este dominio.",
    licenseLimitExceededMessage:
      "Este dominio ha alcanzado el límite de uso de esta licencia. Ve a Empresa > Licenciamiento para ajustar los límites disponibles o contacta al administrador.",
    cannotCreateUserLicenseExceeded:
      "No se puede crear el usuario porque una o más licencias seleccionadas han superado el límite del dominio.",

    uploadImage: "Subir imagen",
    loginAndPasswordManagement: "Gestión de inicio de sesión y contraseña",
    loginAndPasswordManagementDescription:
      "Contraseña asignada para acceso a Gmail",
    loginAndPasswordManagementDescriptionWithControl:
      "Contraseña asignada para acceso a Gmail por Google y por Conecta Control",
    createPassword: "Crear una contraseña",
    generateAStrongPassword: "Generar automáticamente una contraseña segura",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    copyOnNextStep: "Podrás ver y copiar la contraseña en el siguiente paso",
    requestPasswordChange:
      "Solicitar cambio de contraseña en el próximo inicio",
    createAndAdvance: "Crear y avanzar",
    shifts: "Turnos",
    showingAllShifts: "Mostrando todos los turnos",
    searchShift: "Buscar turno",
    selectedShifts: "turnos seleccionados",
    participants: "Participantes",
    login: "Inicio de sesión",
    loginTooltipText:
      "Valida si el usuario está en horario laboral mediante software de control de asistencia.",
    logout: "Cierre de sesión",
    logoutTooltipText:
      'Los participantes del turno serán desconectados al finalizar una "regla de acceso" (período) del turno.',
    passwordPolicy: "Política de contraseña",
    passwordPolicyTooltipText:
      "Define en qué intervalo de tiempo los usuarios deben cambiar sus contraseñas personales.",
    allShiftsSelected: "Todos los turnos de la tabla han sido seleccionados.",
    companyResources: "Recursos de la empresa",
    companyCalendars: "Agendas de la empresa",
    finishOnboardingTitle:
      "¡Felicidades! El nuevo usuario ya está listo para iniciar sesión por primera vez.",
    finishOnboardingSubtitle: "Ahora puedes",
    guidanceForSendingAccessToUser:
      "Enviar los datos de inicio de sesión (correo y contraseña) para que el usuario acceda por primera vez.",
    rateExperience:
      "Evalúa tu experiencia con nuestro flujo de creación de usuario.",
    all: "Todos los",
    shiftsSelectedsInPage: "turnos en esta página están seleccionados.",
    shiftsSelectedsInTable: "turnos de la tabla están seleccionados.",
    selectAllShifts: "Seleccionar todos los turnos",
    clearSelection: "Limpiar selección",
    resetSelection: "Restablecer selección",
    changeEvery: "Cambio cada",
    days: "días",
    pointControl: "Control de asistencia",
    nextPasswordChange: "Próximo cambio de contraseña en",
    verifyPlanDrive:
      "Verifica si el plan de Drives de Google Workspace está activo para tu empresa.",
    companySharedDrivesNotFound:
      "No se encontraron los drives compartidos de la empresa",

    instructions: {
      userCreated: "¡El usuario ya fue creado en tu Panel de Workspace!",
      reminderInfos:
        "Recuerda informar al usuario su correo y la contraseña configurada para el inicio de sesión.",
      recommendations:
        "Recomendamos realizar la <strong>sincronización de usuarios</strong> en Conecta Suite para mantener la lista actualizada correctamente.",
      copyLoginInstructions: "Copiar información de acceso",
      sendLoginInstructions: "Enviar instrucciones de acceso",
      sendInfoDescription:
        "Se enviará un correo con las credenciales de inicio de sesión directamente a la dirección del usuario.",
      templateEmail: {
        subjectEmail:
          "Tienes una cuenta de Google Workspace para {company_name}",
        content:
          '<div style="font-family: inherit; text-align: start"><span>Hola,</span></div><div text-align: start"><br></div><div><span>Tienes una nueva cuenta de Google Workspace en la organización {company_name}.<br>Tus credenciales para el primer acceso son:</span></div><div><span><strong>Correo electrónico</strong></span><span>: {user_email}</span></div><div><span><strong>Contraseña</strong></span><span>: {user_password}</span></div><div><br></div><div><span>Utiliza </span><a href="https://mail.google.com/"><span><u>Gmail</u></span></a><span> para iniciar sesión&nbsp;</span></div><div><br></div><div><span>Después de acceder, es importante cambiar la contraseña y asegurar la protección de tu cuenta.<br>Atentamente,<br>Equipo Conecta Suite</span></div>',
      },
    },

    controlShift: {
      infoAboutThisStep:
        "Asigna al usuario turnos de trabajo configurados en Conecta Control.",
      createShift:
        'Si es necesario, crea un nuevo turno y usa el botón "Recargar turnos" para actualizar la tabla.',
      noShifts:
        'Aún no tienes turnos. Haz clic en "Crear Turnos" y define los horarios de inicio y fin de cada turno.',
      hasNotAccessedControlYet: "Aún no accediste a Conecta Control.",
      hasNotAccessedControlYetDescription:
        "Accede ahora y aprovecha los beneficios del control de acceso de usuarios.",
    },

    fillRequiredFields:
      "Completa los campos obligatorios y haz clic en 'Crear y avanzar'",
    selectOrCreateUser:
      "Selecciona o crea un usuario para continuar al siguiente paso",
  },

  userInformations: {
    workPhone: "Teléfono del trabajo",
    office: "Cargo",
    signaturePhotoUrl: "URL de la foto de la firma",
    signaturePhotoUrlTooltipText:
      "Para evitar problemas con las imágenes de tus usuarios, se recomienda que la imagen de <b>cada usuario sea una URL de una imagen compartida con todos en Google Drive</b>. También puedes utilizar <b>imágenes alojadas en tu propio servidor</b>.",
    userInfosDescription:
      "La información del usuario será guardada en su perfil de Google Workspace.",
    urlForScheduling: "URL para agendamiento",
    customTag1: "Etiqueta personalizada 1",
    customTag2: "Etiqueta personalizada 2",
    customTagTooltipText:
      "Agrega información personalizada para usar en tus modelos de firma",
    customTagPlaceholder1: "Contenido de la etiqueta personalizada 1",
    customTagPlaceholder2: "Contenido de la etiqueta personalizada 2",
    mobilePhone: "Teléfono móvil",
    departament: "Departamento",
    shedulingHelpText:
      "Aprende cómo crear un enlace de agendamiento en Google Calendar <a target='_blank' style='text-decoration: none' href='https://youtu.be/lmJ5clI-bwo'><b>haciendo clic aquí</b></a>.",
    title: "Editar información del usuario",
    alertTagInfoText:
      'La información personaliza el correo de la firma del usuario. Más información en <a target="_blank" class="accent--text" href="https://conectasuite.com/perguntas-frequentes/conecta-sign/como-usar-tags-na-assinatura-de-e-mail/">cómo usar la información en tu firma de correo.</a>',
    personalInformation: "Información personal",
    employeelInformation: "Información del empleado",
    customInformations: "Información personalizada",
    nameAndLastName: "Nombre + Apellido",
    editOnlyInWorkspace:
      "Este campo solo puede modificarse en la cuenta de Google Workspace del usuario",
    addNewTag: "Agregar nueva etiqueta",
    newCustomTag: "Nueva etiqueta personalizada",
    representation: "Representación",
    whatsapp: "WhatsApp",
    extension: "Extensión",
    userPhoto: "Foto del usuario",
    photoTooltipText:
      "Para usar una foto de firma, sube la imagen a tu Drive, copia el enlace y pégalo aquí. Asegúrate de que el enlace sea público.",
    upload: "Subir",
    addImage: "Agregar imagen",
    selectImage: "Seleccionar imagen",
    imageSavedOnDrive: "La imagen será guardada en tu Drive",
    deleteCustomTag: "Eliminar etiqueta personalizada",
    deleteCustomTagDescription:
      "¿Deseas confirmar la eliminación de la etiqueta?",
    confirmInformationChanges: "¿Confirmar cambios en la información?",
    saveInWorkspaceInfoText:
      "Al editar los campos a continuación, los cambios se aplican automáticamente también en Google Workspace",
    saveInWorkspaceCheckboxText:
      "¿Deseas actualizar los datos del usuario en el Workspace?",
    reapplyConfirmationText:
      "¿Deseas volver a aplicar el modelo de firma con la nueva información para el usuario?",
    reapplyEmailSignature: "Volver a aplicar firma de correo",
    request: "Solicitar actualización de la información",
    emailSending:
      "Se enviará un correo con un enlace exclusivo para que cada usuario actualice su información.",
    process: "El proceso de actualización es muy simple:",
    emailReceipt:
      "Recepción del correo: cada usuario recibe un correo con un enlace personalizado.",
    linkAccess:
      "Acceso al enlace: al hacer clic, el usuario es dirigido para actualizar sus datos.",
    deadline:
      "El plazo para realizar los cambios es de 7 días desde la recepción del correo.",
    organizationUnitDescription:
      "Unidad organizacional del usuario configurada en Google Workspace",
    departamentDescription: "Departamento del usuario configurado en Workspace",
    officeDescription: "Cargo del usuario configurado en Workspace",
    function: "Función",
    functionDescription:
      "Indica si el usuario es administrador o solo miembro en Workspace",
    usersShouldApply: "El usuario también debe aplicar la firma de correo",
    endDate: "Fecha de finalización",
    initVacationDate: "Fecha de salida",
    endVacationDate: "Fecha de retorno",
    shiftStatus: "Estado del turno",

    emptyState: {
      signature: {
        noData: "No se encontraron registros de firmas de correo",
        cta: "Aplica tu primera firma haciendo clic en el botón abajo.",
      },
      permissions: {
        noData: "No se encontraron permisos configurados",
        cta: "Define permisos de acceso haciendo clic en el botón abajo.",
        action: "Gestionar permisos",
      },
      vacation: {
        noData: "No se encontraron mensajes de vacaciones configurados",
        cta: "Aplica un mensaje de vacaciones haciendo clic en el botón abajo.",
      },
      delegates: {
        noData: "No se encontraron registros de buzones delegados",
        cta: "Delégale acceso a los buzones haciendo clic en el botón abajo.",
        action: "Delegar acceso",
      },
      vacationControl: {
        noData: "No se encontraron usuarios con vacaciones activas",
        cta: "Define vacaciones para uno o más usuarios haciendo clic en el botón abajo.",
      },
      shifts: {
        noData: "Aún no has configurado turnos de trabajo",
        cta: "Configura turnos de trabajo haciendo clic en el botón abajo.",
        action: "Configurar turnos",
      },
    },

    upsellState: {
      title: "Funcionalidad restringida a planes avanzados",
      signature: {
        call: "A partir del plan Standard puedes usar modelos o crear tu firma de correo personalizada desde cero.",
      },
      vacation: {
        upgrade:
          "Haz upgrade para usar modelos listos de mensajes de vacaciones.",
      },
      vacationControl: {
        call: "A partir del plan Security puedes controlar el acceso de tus colaboradores cuando estén de vacaciones.",
        default:
          "Haz upgrade y gestiona de forma optimizada el acceso de tus usuarios.",
      },
      shifts: {
        call: "A partir del plan Security puedes controlar el acceso de tus colaboradores creando turnos personalizados.",
      },
    },
  },

  feedbackRating: {
    rating_error: "Selecciona un nivel de satisfacción para enviar la encuesta",
    leaveAComment: "Deja un comentario",
    noRating: "Sin evaluación",
    veryDissatisfied: "Muy insatisfecho",
    dissatisfied: "Insatisfecho",
    indifferent: "Indiferente",
    satisfied: "Satisfecho",
    verySatisfied: "Muy satisfecho",
    sendSugestion: "Enviar sugerencia",
    didNotWork: "No funcionó",
    confusingInterface: "Interfaz confusa",
    slowPerformance: "Rendimiento lento",
    incorrectInformation: "Información incorrecta",
    incorrectSignature: "Firma incorrecta",
    tooComplexModel: "Modelo muy complejo",
    moreOptionsNeeded: "Faltan más opciones",
    incorrectChanges: "Cambios incorrectos",
    incorrectDelegation: "Delegación incorrecta",
    emailNotFound: "Correo no encontrado",
    incorrectEmail: "Correo incorrecto",
    why: "¿Por qué?",
    evaluationRegistered: "Todo listo, ¡evaluación registrada!",
    rateOnMarketplace: "Evalúa la aplicación en el marketplace",
    newAssessment: "Nueva evaluación",
  },

  login: {
    slogan: `<span class="login-text-spotlight">Gestión</span> simplificada de <span class="login-text-spotlight">usuarios corporativos</span>`,
    title: "Conecta gestión con tecnología",
    accessDelegation: "Delegación de acceso",
    emailSignature: "Firmas de correo",
    muchMore: "¡y mucho más!",
    createAccountTerms: "Al crear una cuenta, aceptas nuestros",
    termsOfUse: "Términos de uso",
    privacyPolicy: "Política de privacidad",
    businessManagementSystem: "Sistema de gestión empresarial",
    riskReduction: "Reducción de riesgos",
    agileUserManagement: "Gestión ágil de usuarios",
    moreSecurity: "Más seguridad",
    signIn: "Crear cuenta",
    logIn: "Iniciar sesión",
    wrongCredentials: "¡Correo o contraseña incorrectos! Intenta de nuevo.",
    typeValidEmail: "¡Ingresa una dirección de correo válida!",
    typeEmailNotInUse:
      "Correo ya utilizado. Inicia sesión o elige otro correo.",
    typeEmail: "Ingresa tu correo",
    typePassword: "Ingresa tu contraseña",
    passwordsDoNotMatch: "Las contraseñas no coinciden. ¡Intenta de nuevo!",
    enter: "Entrar",
    register: "Registrar",
    forgotPassword: "Olvidé mi contraseña",
    welcomeTo: "Bienvenido a",
    repeatPassword: "Repetir contraseña",
    typePasswordAgain: "Vuelve a ingresar la contraseña",
    loginGoogle: "Iniciar sesión con Google",
    loginMicrosoft: "Iniciar sesión con Microsoft",
    readAndAgreed: `He leído y acepto la <a href="https://conectasuite.com/politica-de-privacidade" target="_blank">@.lower:login.privacyPolicy</a> y los <a href="https://conectasuite.com/termos-de-uso" target="_blank">@.lower:login.termsOfUse</a> de Conecta Suite.`,
    new: {
      createAccountTerms: `Al acceder, aceptas las directrices de la <a href="https://conectasuite.com/politica-de-privacidade" target="_blank">@.lower:login.privacyPolicy</a> y los <a href="https://conectasuite.com/termos-de-uso" target="_blank">@.lower:login.termsOfUse</a>.`,
    },
    recaptchaError: "¡Por favor, confirma que no eres un robot!",
  },

  dashboard: {
    conectaSign: {
      description:
        "Gestiona firmas de correo de forma simple y rápida. Crea modelos personalizados o utiliza nuestros modelos listos y edita en masa para todos los usuarios, manteniendo la identidad de tu empresa.",
      shortDescription:
        "Crea y edita firmas de correo y mensajes de vacaciones para todos los usuarios de Google Workspace",
    },
    conectaTrack: {
      description:
        "Conoce automáticamente en qué se están utilizando las horas de trabajo. Genera informes por período y ve quién está en línea en tiempo real.",
      shortDescription:
        "Monitorea y registra automáticamente actividades en Google Chrome",
    },
    conectaControl: {
      description:
        "Define quién puede acceder a las herramientas de Google Workspace (G Suite) desde cualquier lugar y en cualquier momento, o solo desde la oficina durante el horario laboral. Ahora con migración de datos: optimice la transición con pocos clics, sin esfuerzo manual y con total seguridad.",
      shortDescription:
        "Controla accesos según horarios y ubicaciones de uso del Google Workspace",
    },
    conectaSuite: {
      description:
        "¡Esta opción forma parte del panel administrativo de la empresa!",
      shortDescription: "",
    },
    workspaceDiagnosis: {
      description: "Identifica posibles problemas y mejoras para tu empresa",
      shortDescription: "",
    },
    manageAdmins: {
      description:
        "Gestiona administradores y otorga accesos exclusivos para gestores",
      shortDescription: "",
    },
    reseller: {
      description:
        "Gestiona a tus clientes y revisa la facturación a través del panel administrativo",
      shortDescription: "Gestiona a tus clientes desde el panel de socios",
    },
    companyProfile: {
      description: "¡Gestiona los datos del perfil de tu empresa!",
      shortDescription: "Actualiza y visualiza la información de la empresa",
    },
    billing: {
      description:
        "Accede a tus suscripciones, servicios e historial de facturación",
      shortDescription:
        "Gestiona los planes contratados por la empresa y el historial de facturación",
    },
    users: {
      description:
        "Configura: mensaje de vacaciones, delegación de acceso, envío como y firma de correo",
      shortDescription: "",
    },
    inventory: {
      description: "¡Gestiona el inventario digital de tu empresa!",
      shortDescription: "",
    },
    reports: {
      description: "¡Consulta informes de actividad de los usuarios!",
      shortDescription: "",
    },
    contactUs: {
      description: "¿Podemos ayudarte?",
      shortDescription: "",
    },
    manageEmailSignatures: "Gestionar firmas de correo",
  },

  upgradeBanner: {
    trialTitleExpired: "¡Ups, tu período de prueba ha finalizado!",
    trialSubtitleExpired:
      "Adquiere un plan para seguir disfrutando de todas las funcionalidades de Conecta Suite.",
    trialTitlePeriod: "¿Te está gustando Conecta Suite?",
    trialSubitlePeriod:
      "Asegura tu plan sin perder los días restantes de prueba gratuita. ¡Planes desde R$2,50/usuario/mes!",
    subtitleUpgradeTextDense:
      "Desbloquea más funciones. Explora, crea o personaliza modelos de firma y aplícalos en masa.",
    standardPlanAndUp: "Disponible a partir del plan Standard.",
    subtitleUpgradeTextNotDense:
      "Desbloquea más funciones, controla el acceso por tiempo, ubicación y navegador a Workspace con Conecta Control",
    subtitleUpgradeTextHasBasic:
      "Más funciones: aplica firmas y mensajes de vacaciones en masa",
    subtitleUpgradeTextNotBasic:
      "Más funciones: controla el acceso por tiempo, ubicación y navegador a Workspace",
    upgradePlan: "Actualización disponible para ti",
  },

  functionalities: {
    licenseManager: "Gestionar licencias",
  },

  scopesAlert: {
    alertTitle: "¡Atención!",
    emailMigration: {
      alertMessage:
        "Identificamos que hay permisos pendientes en la aplicación Conecta Suite",
      resolveScopes:
        "El funcionamiento adecuado de la migración de correos depende de la autorización de estos permisos.",
    },
    driveMigration: {
      resolveScopes:
        "El funcionamiento adecuado de la transferencia de archivos depende de la autorización de estos permisos.",
    },
    alertMessage1:
      "Para evitar problemas de funcionamiento en Conecta Suite, por favor, <b>autoriza los accesos</b> necesarios en el <b>{provider} Workspace</b>",
    alertMessage2:
      "Si tienes dudas, contacta a nuestro equipo de soporte por los canales de atención.",
    alertMessage3:
      "Contacta al administrador de tu Google Workspace para solicitar la autorización de los permisos necesarios.",
    alertMessage4:
      "Esta es una resolución <strong>urgente</strong> y garantiza que todas las funcionalidades operen sin interrupciones.",
    requestAdminToAcceptScopes:
      "Por favor, solicita a tu administrador que acepte los permisos para utilizar esta funcionalidad.",
    requestToAcceptScopes:
      "Por favor, acepta los permisos en tu Google Workspace para utilizar esta funcionalidad.",
    alert:
      "La funcionalidad de {functionality} no está disponible debido a la falta de permisos en la aplicación.",
  },

  scheduleMeeting: {
    message:
      "Como eres nuevo por aquí, ¿qué tal si agendas una conversación con nuestro equipo de especialistas para resolver todas tus dudas?",
    talkToOurSpecialists: "Habla con nuestros especialistas",
    knowOurPlans: "Conoce nuestros planes",
  },

  driveMigration: {
    title: "Transferencia de archivos",
    steps: {
      intro: {
        title: "Introducción",
        subtitle: "Ventajas de la transferencia de archivos de Conecta Suite",
      },
      processes: {
        title: "Procesos",
        subtitle:
          "Retoma procesos en curso, inicia nuevos o visualiza los completados",
      },
      start: {
        title: "Iniciar",
        subtitle:
          "Selecciona el Drive de un usuario y un grupo para el Drive compartido.",
      },
      prepare: {
        title: "Preparar",
        subtitle:
          "Espera mientras preparamos los datos para iniciar el proceso.",
      },
      executing: {
        title: "Ejecución",
        subtitle:
          "Realiza la transferencia de archivos solo o junto a otros colaboradores.",
      },
    },
    intro: {
      title: "Transfiere archivos de tus colaboradores",
      description:
        "Utilizando el Drive compartido de tu empresa, puedes reducir el uso de almacenamiento de tus colaboradores sin eliminar el acceso a los archivos. Realiza esta transferencia siguiendo las buenas prácticas de Google Workspace.",
      benefits: {
        1: "Reduce el uso de almacenamiento de los colaboradores",
        2: "Aprovecha mejor el almacenamiento compartido",
        3: "Gestiona el acceso a los archivos mediante grupos de Workspace",
      },
    },
    processes: {
      title: "Procesos",
      resume:
        'Si deseas ejecutar un proceso aún no concluido, haz clic en "Retomar".',
      start: 'Haz clic en "Iniciar proceso" para comenzar uno nuevo.',
      callSupport:
        "Contacta con nuestro soporte para identificar un posible fallo.",
    },
    start: {
      title: "Iniciar proceso",
      userTip: "Este es el usuario cuyos archivos serán transferidos.",
      groupAlertTitle:
        "Si acabas de crear el grupo de correo, puede que aún no aparezca en la lista.",
      groupAlertBody:
        "Esto ocurre porque Google puede tardar hasta <b>24h</b> en actualizar y reconocer el nuevo grupo. Para visualizar los grupos actualizados, <b>haz clic en el botón de recarga junto al campo</b> — esto buscará los grupos vinculados al usuario seleccionado.<br><br>Recuerda: el usuario debe formar parte del grupo de destino.",
      groupReloadButton: "Recargar grupos del usuario",
      groupTip:
        'Selecciona un grupo del usuario y haz clic en "Preparar" para transferir los archivos.',
      selectGroup: "Seleccionar grupo",
      tryUser: "Intenta seleccionar un usuario primero",
      startTransfer: "Iniciar transferencia del Drive",
      userAccessDrive: "Usuarios que tendrán acceso al Drive compartido",
      hasExternalMember:
        "¡Atención! ¡Algunos miembros de este grupo pueden ser externos!",
      tooltipLabel:
        "Estos usuarios recibirán un correo informando sobre el acceso a este Drive compartido y podrán ver y acceder a los archivos contenidos.",
    },
    prepare: {
      loading: "Preparando lotes y creando carpetas...",
      waitFinish:
        "Por favor, espera. Este proceso puede tardar algunos minutos.",
      ready: "¡Todo listo!",
      filesAndFolders: "Número de archivos y carpetas",
      files: "Número de archivos",
      batches: "Número de lotes",
      continue: "Haz clic en avanzar para iniciar la transferencia.",
      folders: "Número de carpetas",
      create: "Carpetas creadas",
    },
    executing: {
      title:
        "Transferencia de archivos de <strong> {email} </strong> al Drive compartido <strong>{group}</strong>",
    },
    tips: {
      batches: {
        total: "Total de archivos",
        finished: "Archivos transferidos",
        missing: "Archivos faltantes",
        failures: "Archivos con errores",
      },
      workers: {
        ran: "Usuarios que ejecutaron",
        running: "Usuarios ejecutando",
        missing: "Usuarios ausentes",
      },
    },
    errors: {
      title: "La transferencia de archivos falló",
      createSharedDrive:
        "No tienes Drives compartidos. Asegúrate de tener una licencia válida de Google Workspace.",
      prepareSharedDrive:
        "No se pudo preparar el Drive compartido. Asegúrate de haber aceptado los permisos.",
      listUserFiles:
        "No se encontraron archivos del usuario seleccionado. Asegúrate de que el usuario sea propietario de los archivos.",
      buildFolders:
        "Ocurrió un error. Intenta nuevamente más tarde o contacta con soporte.",
    },
    startProcess: "Iniciar proceso",
    unavailable: "Disponible solo en el plan Security o superior.",
    tempUnavailable: "Temporalmente no disponible. En mantenimiento.",
    upsellInvitation:
      "La migración de archivos de Drive no está disponible en tu plan. Conoce los planes disponibles y haz upgrade para realizar respaldos mediante transferencia de datos.",
  },

  priceChangeWarning: {
    warning:
      "A partir del <strong>1 de julio de 2026</strong>, los precios de los planes Standard, Security y Enterprise de Conecta Suite serán ajustados según la tabla disponible en el sitio web.",
    noActionNeeded: "No se requiere ninguna acción.",
    willingToHelp:
      "Estamos disponibles para aclarar tus dudas a través del correo electrónico",
    thanks4BeeingClient: "Gracias por ser cliente de Conecta Suite.",
    iUnderstood: "Entendido",
    subtitle: "Aviso sobre ajuste de precios de los planes",
    priceAdjustment: "Ajuste en el precio de los planes",
  },

  emailMigration: {
    upsellInvitation:
      "La migración de correos electrónicos no está disponible en tu plan. Conoce los planes disponibles y haz upgrade para realizar respaldos de correos mediante transferencia de datos.",
    title: "Migración de correos",
    subtitle:
      "Haz respaldo de los correos de un usuario a un grupo de Google Workspace. Solo una migración empresarial puede realizarse a la vez.",
    steps: {
      intro: {
        title: "Introducción",
        subtitle: "Ventajas de la migración de correos de Conecta Suite",
      },
      processes: {
        title: "Transferencias",
        subtitle:
          "Retoma transferencias en curso, inicia nuevas o visualiza las completadas",
      },
      start: {
        title: "Iniciar",
        subtitle: "Selecciona el correo de un usuario y el grupo de destino.",
      },
      prepare: {
        title: "Preparar",
        subtitle:
          "Espera mientras preparamos los datos para iniciar el proceso.",
      },
      executing: {
        title: "Ejecución",
        subtitle: "Realiza la migración solo o con otros colaboradores.",
      },
    },
    intro: {
      title: "Migra correos de tus colaboradores",
      description:
        "Migra correos de tus colaboradores a grupos de Workspace de forma segura. Puedes iniciar o pausar los procesos en cualquier momento.",
      benefits: {
        1: "Reduce la pérdida de información por eliminación de correos importantes",
        2: "Aprovecha los recursos de los grupos",
        3: "Gestiona el acceso a los correos a través de grupos de Workspace",
      },
    },
    start: {
      title: "Iniciar proceso",
      userTip: "Selecciona el usuario cuyos correos serán migrados:",
      groupTip: "Selecciona el grupo de destino:",
      selectGroup: "Seleccionar grupo",
      tryUser: "Selecciona un usuario primero",
      startDateTip: "Selecciona la fecha de inicio de los correos:",
      selectStartDate: "Seleccionar fecha de inicio",
      theEntirePeriod: "Todo el período",
      pastYear: "Último año",
      past1Month: "Último mes",
      customPeriod: "Período personalizado",
      includeSpamAndTrashTip: "¿Deseas incluir correos de spam o papelera?",
      includeSpamAndTrash: "Incluir correos de spam o papelera",
    },
    prepare: {
      loading: "Preparando lotes...",
      ready: "¡Todo listo!",
      files: "Número de correos",
      batches: "Número de lotes",
      continue: "Haz clic en avanzar para iniciar la migración.",
    },
    executing: {
      title: "Migración de correos de {email} al grupo {group}",
    },
    tempUnavailable: "Temporalmente no disponible. En mantenimiento.",
    includeTrashTip: "¿Deseas migrar los correos de la papelera?",
    includeTrashLabel: "Incluir correos de la papelera",
    initMigration: "Iniciar migración",
    selectGroupTip: "Selecciona el grupo al cual deseas migrar los correos de ",
    migrateEmailsFromDate: "Elige el período para la migración",
    dialog: {
      subtitle: "Migración de correos a grupos",
      alert: "Antes de comenzar la migración de correos, ten en cuenta:",
      timeToFinishInstruction:
        "La migración puede tardar desde minutos hasta algunas horas.",
      closePageInstruction:
        "Puedes cerrar esta página. El proceso continuará en segundo plano.",
      maxMailSizeTip: "Solo se migrarán correos de hasta 25MB.",
      transferBackground:
        "La transferencia se realiza en segundo plano, para que puedas continuar el proceso de eliminación del usuario sin interrupciones.",
    },
    overlay: {
      migrationRunning:
        "Ya existe una migración en curso. No es posible iniciar migraciones simultáneas a nivel empresarial. Espera a que finalice.",
      missingScopesAlert:
        "La funcionalidad de migración de correos no está disponible por falta de permisos en la aplicación.",
    },
    startMigrationDateDescription:
      "La migración abarca desde hoy hasta la fecha seleccionada.",
    trashEmailTooltip:
      "El período de migración también se aplica a la papelera.",
    emailsMigrated: "Correos migrados",
    successfullyMigrated: "Migrados con éxito",
    migrationFailure: "Fallo en la migración",
    groupEmailTransfer: "Transferencia de correos a grupos",
    migration_time_range: "Período migrado: {start} a {end}",
    migration_config_info: "Configuración de la migración",
    migration_processing_details: "Detalles del procesamiento",
    total_completed_items: "Correos migrados",
    total_failures_items: "Correos con errores",
    status_code: "Estado de la migración",
    total_items_length: "Total de correos a migrar",
    total_messages_size: "Tamaño total de los correos migrados",
    extra_information: "Información adicional",
    error_code: "Error",
    running: "En curso",
    failed: "Finalizada con errores",
    finished: "Finalizada",
    error: "Error ocurrido",
    no_details_in_queue:
      "Esta migración aún no ha comenzado. Los datos se mostrarán cuando se inicie el proceso.",
    no_details_interrupted:
      "La migración fue interrumpida y los datos ya no se actualizarán.",
    no_details_canceled:
      "La migración fue cancelada. No hay datos para mostrar.",
    no_details_error:
      "No se encontraron los detalles de esta migración. Verifique si el proceso se ha iniciado o intente nuevamente más tarde.",
    not_found: "No encontrado",
    loading: "Cargando...",
  },

  offboardingUser: {
    welcomeOffboardingTitle: "Bienvenido al proceso de eliminación de usuario",
    welcomeOffboardingSubtitle: "Antes de comenzar, debes saber",
    totalStepsLabel: "Este es un proceso de 7 etapas",
    progressAutomaticSaveLabel:
      "Puedes pausar este proceso en cualquier momento y tu progreso se guardará automáticamente.",
    suportHelperLabel:
      "Si tienes dudas, puedes contactar a nuestro soporte a través de los canales de atención.",
    selectTheUser: "Seleccionar usuario",
    suspendTheUser: "Suspender usuario",
    suspendTheUserCheckboxLabel:
      "El usuario seleccionado será bloqueado para acceder a la cuenta y será desconectado. Sus datos se conservarán, pero no recibirá correos electrónicos, invitaciones de calendario ni archivos mientras esté suspendido. Los usuarios suspendidos pueden ser restaurados, siempre que no sean eliminados.",
    changePassword: "Cambiar contraseña",
    changePasswordDescription:
      "Restablece la contraseña del usuario para evitar que acceda a la cuenta si la suspensión se elimina en el futuro.",
    removeFromControlShifts: "Quitar de los turnos del control",
    passwordRuleMessage:
      "La contraseña debe tener más de 8 y menos de 100 caracteres",
    offboardingCompleted: "Proceso de eliminación de usuario finalizado",
    offboardingFailure: "Se produjo un error al finalizar el proceso",
    companyNoHasConectaControl: "Tu plan actual no incluye Conecta Control",
    actionsExecuted: "Acciones ejecutadas",
    appsUser: {
      ofUser: "Aplicaciones conectadas al usuario {user_email}",
      subtitle:
        "Para visualizar las aplicaciones, haz clic en el botón 'Sincronizar aplicaciones' y luego selecciona las que deseas desconectar del usuario:",
      upsell: {
        title: "Funcionalidad restringida a planes avanzados",
        call: "A partir del plan Standard puedes verificar aplicaciones conectadas de tus colaboradores.",
      },
      empty: {
        title: "No se encontraron registros de aplicaciones conectadas",
        cta: "¡Sincroniza las aplicaciones conectadas de tu colaborador haciendo clic en 'Sincronizar'!",
        next: "Las aplicaciones se sincronizaron correctamente, pero no se encontró ninguna. Puedes continuar haciendo clic en 'Siguiente'.",
      },
      notFoundConnection: "No se encontraron conexiones con esta aplicación.",
      notDisconnected: "Algunas conexiones no pudieron eliminarse: {data}",
      moreThan180Days: "Hace más de 180 días.",
    },
    finishOfboardingTitle:
      "¡Felicidades! El proceso de eliminación del usuario ha sido finalizado.",
    removeLicenseAfterMigration:
      "La licencia del usuario {email} se eliminará después de la transferencia de datos.",
    notifyViaEmail:
      "Recibirás una notificación cuando se completen las migraciones.",
    removeUserFromSuite:
      "El usuario será eliminado del Suite tras la sincronización, pero puedes acceder a él directamente en el Workspace.",
    transferEmailTitle:
      "Respaldo de correos electrónicos con transferencia de datos",
    transferEmailSubtitle:
      "Migrar correos electrónicos de un usuario a un grupo de Google Workspace garantiza que la información importante permanezca accesible al equipo, promoviendo la colaboración y transparencia en la redistribución de responsabilidades.",
    transferDriveTitle: "Transferencia de archivos de Drive",
    transferDriveSubtitle:
      "Transfiere los archivos del Drive del usuario a un Drive compartido para no perder los archivos e información vinculada a él.",
    selectGroupToTransfer:
      "Para iniciar la transferencia, elige un grupo al cual el usuario pertenezca.",
    transferArquives: "Transferir archivos",
    licenseAssignTitle: "Gestión de licencias",
    licenseAssignSubtitle:
      "Eliminar licencias de ex empleados evita gastos innecesarios por licencias no utilizadas, optimizando el presupuesto de la empresa. Esta acción <b>no elimina al usuario de Google Workspace</b>. <br> Para eliminar al usuario, accede directamente al panel de Google. <a class='link blue--text' href='https://admin.google.com/ac/users'> Abrir panel de Google Workspace</a>.",
    licenseAssignAlert:
      "Las licencias solo se eliminarán después de completar la migración de los datos de Drive, correo electrónico y calendario.",
    noLicensesAssigned: "Ninguna licencia asignada",
    in_queue: "En cola",
    exectutionOrder: "Orden de ejecución",
    hasTaskRunningAlert:
      "Ya hay una migración de correos en curso. La migración del correo de {email} se agregará a la cola y se ejecutará al finalizar la migración actual.",
    migrationsInQTitle: "Migración de correo electrónico en cola",
    migrationsInQSubtitle:
      "Cuando finalice la migración actual, el sistema iniciará la siguiente.",
    conecta_control_shifts: "Turnos de Conecta Control",
    remove_user_shifts:
      "Elimina al usuario de todos los turnos de Conecta Control para bloquear su acceso y mantener organizada la rotación de turnos.",
    update_password:
      "La nueva contraseña del usuario se actualizará en Conecta Control y en Google Workspace.",
    suspend_user: "Suspender usuario en Google Workspace",
    hasTransferenceRunningAlert:
      "Ya hay una transferencia de archivos de Drive en curso. Espera a que finalice antes de iniciar otra.",
  },

  dialogHasProduct: {
    yourCompany: "Tu empresa aún no tiene el {product}",
    yourCompanyPlan: "Este recurso está disponible a partir del Plan {plan}",
    knowBenefits:
      'Conoce todos los beneficios de {product} haciendo clic en "Saber más"',
    knowPlanBenefits:
      'Conoce todos los beneficios del Plan {product} haciendo clic en "Saber más"',
    trialExpired: "Período de prueba expirado",
    askAdmin: "¡Solicita al administrador que libere tu acceso!",
    notAdminOf: "No eres administrador de ",
  },

  applySignature: {
    viewAppointments: "Ver citas",
    goToUsers: "Ir a usuarios",
    viewEmailSignatures: "Ver firmas de correo electrónico",

    signatureChangeRequestSent:
      "¡Solicitud de cambio de firma enviada por correo electrónico!",
    signatureChangeScheduledSuccess:
      "¡Cambio de firma de correo electrónico programado con éxito!",
    signatureAppliedSuccess: "¡Uhul! Firma de correo aplicada 🎉",

    exclusiveLinkSignatureChange: "Cambio de firma por enlace exclusivo",
    exclusiveLinkEmailDescription:
      "Cada usuario seleccionado recibirá un correo electrónico con un enlace exclusivo para cambiar su firma",
    fillOutInformation: "Rellenar información",
    exclusiveLinkInformationDescription:
      "El enlace exclusivo también permite que los usuarios completen su información personal",

    signatureChangeScheduled: "¡Cambio de firma programado!",
    signatureScheduledDescription:
      "Conecta Suite aplicará la firma en la fecha programada.",
    signatureAppliedGmail: "¡La firma fue aplicada!",
    signatureDelayDescription:
      "La firma puede tardar hasta 15 minutos en visualizarse.",
    restrictedUserAcceptance:
      "Los usuarios marcados como restringidos deberán aceptar la aplicación para que sus firmas sean modificadas",
    learnMoreRestrictedUsers:
      'Conoce más sobre usuarios restringidos <a href="https://www.youtube.com/watch?v=z5XSGuJFxPw" target="_blank">haciendo clic aquí</a>.',

    signatureSentViaEmailTitle: "¡Firma enviada por correo!",
    signatureSentViaEmail: "Correo con firma enviado a los colaboradores",
    signatureSentViaEmailDescription:
      "Se envió un correo con la firma en Texto Enriquecido y HTML a cada colaborador seleccionado solicitando su aplicación manual.",

    viewEmailSignature: "Ver firma de correo electrónico",
    applyEmailSignatureDescription:
      "La firma se aplicará inmediatamente a los usuarios seleccionados.",
    userWillapplyEmailSignatureDescription:
      "Al confirmar esta acción, los correos serán enviados de inmediato.",
    scheduleEmailSignatureDescription:
      "La programación puede cancelarse antes de la fecha de ejecución.",
    scheduleEmailSignatureApplication: "Programar aplicación de firma",
    scheduleEmailSignatureApplicationDescription:
      "La firma será aplicada en la fecha seleccionada.",

    usersApplyTheirOwnSignature:
      "Solicitar que completen los datos y apliquen la firma",
    usersApplyTheirOwnSignatureDescription:
      "Los usuarios recibirán un enlace para completar su información y aplicar el modelo de firma al correo.",

    sendSignatureViaEmail: "Enviar firma por correo",
    sendSignatureViaEmailDescription:
      "Los usuarios recibirán el modelo de firma para copiarlo y aplicarlo manualmente.",

    applyEmailSignature: "Aplicar firma de correo electrónico",
    applyVacationMessage: "Aplicar mensaje de vacaciones",
    selectSignatureModel: "Seleccionar modelo de firma",
    customModels: "Modelos personalizados",
    defaultModels: "Modelos predeterminados",
    popular: "Popular",
    deleteModel: "Eliminar modelo",
    editModel: "Editar modelo",
    duplicateModel: "Duplicar modelo",
    emptySignature: "Esta firma está vacía",
    missingInfoAlertText:
      "Uno o más usuarios no tienen información presente en este modelo.",
    actionTextToCorrectInformation:
      "Haz clic sobre el usuario para corregir la información faltante.",
    editInformation: "Editar información de",
    applyModel: "Aplicar modelo",
    messageDelayToApply: "La firma puede tardar hasta 10 minutos en aplicarse.",
    confirmApply:
      "Los usuarios seleccionados tendrán su firma modificada. <strong>¿Deseas continuar?</strong>",
    infoScheduleApply:
      "La firma será aplicada en la fecha indicada y tiene un límite de 30 días.",
    scheduleApplication: "Programar aplicación de firma",
    notifyUsers: "Notificar a todos sobre la nueva firma",
    notifyUsersScheduled:
      "Notificar a los usuarios luego de la aplicación de firma",
    infoNotifyUsers:
      "Los usuarios restringidos recibirán el correo independientemente de esta opción.",
    signatureModels: "Modelos de firma",
    viewInList: "Ver en lista",
    viewInGrid: "Ver en cuadrícula",
    goToApplication: "Ir a aplicación",
    defineModelToNewUsers: "Definir firma para nuevos usuarios",
    uncheckModelToNewUsers: "Desmarcar modelo para nuevos usuarios",
    automaticApplication: "Aplicación automática",
    newModel: "Nuevo modelo",
    deleteSignatureModel: "Eliminar modelo de firma",
    deleteSignatureModelWarning:
      "Eliminar el modelo no elimina la firma del Gmail de los usuarios, pero quedarán sin modelo asignado en Conecta Suite.",
    defineModelToNewUsersDescription:
      "Define el <b>modelo de firma que se aplicará automáticamente</b> a nuevos usuarios del Workspace.",
    confirmModelToNewUsers:
      "Haz clic en <span class='font-weight-bold text-uppercase'>Confirmar</span> para asignarlo a todos los nuevos usuarios.",
    newUser: "Nuevo usuario",
    signatureConfiguredForNewUsers: "Firma configurada para nuevos usuarios",
    vacationModel: "Modelo de vacaciones",
    applySignatureModelInstructions:
      "Selecciona los usuarios y haz clic en Aplicar firma.",
    applyVacationModelInstructions:
      "Selecciona los usuarios y haz clic en Aplicar mensaje de vacaciones.",
    usersShouldApply:
      "Solicitar que los usuarios completen su información y apliquen la firma",
    usersShouldApplyInfo:
      "Los usuarios recibirán un enlace para rellenar su información, previsualizar el modelo y aplicarlo.",
    availableForPrimary: "Disponible solo para correos principales.",
    turnOnTour: "Activar tutorial de modelos",
    turnOffTour: "Desactivar tutorial de modelos",
  },

  usersPage: {
    primaryEmails: "Correos principales",
    allEmails: "Todos los correos",
    secondarySearchBy: "Buscar por correo, usuario o nombre asociado",
    primarySearchBy: "Buscar por nombre o correo principal",
    showing: "Mostrando",
    usersOnTableSelecteds: "usuarios de la tabla fueron seleccionados",
    usersOnPageSelecteds: "usuarios de esta página fueron seleccionados",
    selectAllUsers: "Seleccionar todos los usuarios",
    selectAllUsersInSearch:
      "Seleccionar todos los usuarios que coinciden con esta búsqueda",
    clickOnTheUserToConfigureSendas:
      "Haz clic sobre el nombre del usuario para configurar correos secundarios",
    editUsers: "Editar usuarios",
  },

  filters: {
    filters: "Filtros",
    signatureModelApplied: "Modelo de firma aplicado",
    signatureModelAppliedDescription: "Último modelo aplicado al usuario",
    noSignatureModelSelected: "Ningún modelo seleccionado",
    vacationMessageTemplateApplied: "Modelo de vacaciones aplicado",
    vacationMessageTemplateAppliedDescription:
      "Último modelo de vacaciones aplicado al usuario",
  },

  confirmUpdateTags: {
    successfull: "¡Actualización realizada con éxito!",
    invalidLink: "¡Ups! El enlace ya no es válido.",
    editAgain: "Editar información nuevamente",
    updateTags: "Actualizar información",
    previewAndApply: "Previsualizar y aplicar firma",
  },

  missingTags: {
    someAreInUsers: "Faltan datos en algunos usuarios seleccionados",
    allIsFilled: "Toda la información requerida está completa",
    aUserAndATag: "El usuario {name} no tiene completado el dato <b>{tag}</b>",
    aUserAndTags: "El usuario {name} tiene datos faltantes",
    usersAndATag: "{num} usuarios seleccionados no tienen un dato completado",
    usersAndTags: "{num} usuarios seleccionados tienen varios datos faltantes",
  },

  retry: {
    waitingGoogle: "Conectando con Google. Por favor, espera un momento.",
    justInstalled:
      "Si acabas de instalar la aplicación, esto puede tardar algunos minutos.",
    ensureScopes:
      'Asegúrate de haber otorgado los permisos necesarios accediendo al <a href="{link}" target="_blank">panel de Admin</a>.',
  },

  vacationApply: {
    overwriteWarning:
      "Algunos de los usuarios seleccionados ya tienen un mensaje de vacaciones configurado. Aplicar una nueva configuración sobrescribirá el mensaje anterior.",
    intro: {
      subtitle:
        "Conozca qué configuraciones pueden realizarse durante el flujo",
    },
    model: {
      title: "Modelo de mensaje",
      subtitle: "Defina el mensaje que los usuarios utilizarán",
      search: "Buscar modelo en Todos los modelos",
      filter: "Filtrar por tipo de modelo",
      noModelFor: 'No hay modelos coincidentes para la búsqueda "{search}"',
      noCustomModelFor:
        'No hay modelos personalizados coincidentes para la búsqueda "{search}"',
      noDefaultModelFor:
        'No hay modelos predeterminados coincidentes para la búsqueda "{search}"',
      noResultFor: 'No hay resultados coincidentes para la búsqueda "{search}"',
      searchCustom: "Buscar modelo personalizado",
      searchDefault: "Buscar modelo predeterminado",
      allModels: "Todos los modelos",
    },
    configure: {
      title: "Configurar mensaje",
      subtitle: "Elija el período de duración y otras configuraciones",
      pageTitle: "Configuraciones del mensaje de vacaciones",
      description:
        "Configure el período durante el cual se enviará automáticamente el mensaje de vacaciones y quién lo recibirá al contactar con el usuario.",
      vacationPeriod: "Período de vigencia de las vacaciones",
      userSchedule: "Configuraciones de la agenda del usuario",
      addEvent: "Agregar evento de vacaciones en el calendario del usuario",
      eventName: "Vacaciones ⛱️",
      eventTitle: "Título del evento",
      selectEventName: "Elegir nombre del evento en el calendario",
      restrictions: "Restricciones del mensaje automático",
      restrictionsTooltip:
        "Restrinja el mensaje de vacaciones a los contactos del usuario o a usuarios del dominio de la empresa",
      contactsOnly: "Responder solo a los contactos",
      companyOnly: "Responder solo a los usuarios de la empresa",
      forwarding:
        "Reenvío de correos recibidos durante el período de vacaciones",
      forwardingToUser: "Reenviar correos a otro usuario",
      receiver: "Usuario que recibirá los correos",
      selectReceiver: "Seleccionar usuario para recibir los correos",
    },
    absenseSettings: {
      stepTitle: "Configuraciones de ausencia",
      stepSubtitle:
        "Agregue evento de vacaciones y reenvíe correos durante la ausencia",
      title: "Configuraciones de ausencia durante las vacaciones",
      subtitle:
        "Agregue un evento de vacaciones al calendario o reenvíe correos a otro usuario durante el período",
      calendarSettings: "Configuraciones del calendario del usuario",
      addHolidayEvent: "Agregar evento de vacaciones en el calendario",
    },
    startedVacationFlow: {
      title: "Activar mensaje de vacaciones en Google Workspace",
      subtitle:
        "Configure una respuesta automática para indicar que el usuario está de vacaciones.",
      setUpAVacationResponder:
        "Respuesta automática al recibir correos durante las vacaciones.",
      forwardingReceived: "Reenvío de correos a otro usuario",
      addHoliday: "Agregar evento de vacaciones al calendario",
      autoReply: "Definir quién recibirá la respuesta automática",
    },
    save: {
      title: "Guardar cambios",
      subtitle: "Confirme y aplique los cambios",
      gridView: "Cambiar a vista de campo",
      groupView: "Cambiar a vista de grupo",
      noUserFor: 'No se encontró ningún usuario para "{search}"',
      searchUser: "Buscar por nombre, departamento o correo principal",
    },
    manageAccess: {
      title: "Gestionar acceso",
      subtitle: "Administre el acceso durante las vacaciones del usuario",
      description:
        "Controle el acceso de los colaboradores durante sus vacaciones usando Conecta Control.",
      question: "¿Desea bloquear el acceso de sus colaboradores?",
      upsellInvitation:
        "El control de acceso no está disponible en su plan. Conozca los planes disponibles y actualícese.",
      dontBlock: "No bloquear",
      block: "Bloquear acceso durante vacaciones",
      success:
        "El control de acceso durante las vacaciones fue configurado exitosamente.",
      failure:
        "No se pudo configurar el control de acceso durante las vacaciones.",
    },
    concludedVacationFlow: {
      title: "Finalizar",
      subtitle: "Revise los detalles",
      finishFlow: "¡Asignación de vacaciones completada!",
      finishFlowSubtitle:
        "Los detalles completos de las vacaciones configuradas se listan a continuación",
      selectedModel: "Modelo elegido",
      selectedPeriod: "Período definido",
      selectedUsers: "Usuarios seleccionados",
      calendarEvent: "Evento guardado en el calendario",
      forwardingEmail: "Reenvío de correos a",
      templateApplied: "Modelo de respuesta elegido: {modelName}.",
      templateCustomApplied:
        "El modelo de respuesta fue personalizado por usted.",
      rateExperience: "Evalúe su experiencia con nuestro flujo de vacaciones",
    },
  },

  signAutomation: {
    activateTitle: "Activar reaplicación automática de firmas",
    activateSubtitle:
      "Con la reaplicación automática, cada usuario tendrá su firma reaplicada diariamente de forma automática.",
    alertControlPlan:
      "Para activar esta función es necesario contratar el plan Security o superior.",
    alertMassMigrationPlan:
      "Para seleccionar varios usuarios, es necesario contratar el Plan Enterprise. En el Plan Security, la migración solo puede realizarse de un usuario por vez.",
    alertAutomationNotActive:
      "Al activar Sign Automation, la reaplicación automática se aplicará a todos los usuarios con modelo asignado.",
    alertAutomationActive:
      "<b>Sign Automation está activo.</b> Al desactivarlo, las firmas dejarán de reaplicarse automáticamente.",
    activate: "Activar automatización",
    deactivate: "Desactivar automatización",
    scheduledSignatures: "Firmas programadas",
    authorTooltip: "Usuario que ejecutó la acción",
    errorTooltip: "Contacte al soporte para investigar un posible error.",
    signaturePreview: "Ver firma aplicada",
    previewSignatureName: "Viendo firma {name}",
    cancelSchedule: "Cancelar programación",
    applyFor: "Aplicado para",
    successActivate: "Reaplicación automática DESACTIVADA exitosamente",
    successDeactivate: "Reaplicación automática ACTIVADA exitosamente",
    error:
      "No fue posible cambiar la configuración de reaplicación automática.",
    successOnCancel: "Cancelación de programación realizada con éxito",
    errorOnCancel:
      "No se pudo cancelar la programación. Contacte al soporte de Conecta Suite.",
    cancelTitle: "Cancelar programación",
    status: {
      created: "Fallo al programar",
      scheduled: "Programado",
      executed: "Ejecutado",
      deleted: "Cancelado",
    },
  },

  tableHeaders: {
    users: "Usuarios",
    department: "Departamento",
    lastLogin: "Último acceso",
    apps: "Aplicaciones",
    registrationDate: "Fecha de registro",
    scheduleDate: "Fecha programada",
    situation: "Situación",
    author: "Actor",
    signature: "Firma",
    actions: "Acciones",
  },

  reports: {
    reason: "Motivo",
    reasonNotRecorded: "El autor de la acción no registró un motivo.",
    context: {
      stopMigration: "Cancelar/interrumpir migración",
    },
    migration: {
      description:
        "{action} la migración de correo electrónico del usuario {source_email} al grupo {target_email} el día {created_date}",
    },
    description: {
      canceled: "Canceló",
      interrupted: "Interrumpió",
    },
  },

  syncUsers: {
    synchronizingUsers:
      "<b>Sincronizando usuarios</b>: Para realizar algunas tareas es importante esperar hasta que finalice la sincronización.",
  },

  newDashboard: {
    meeting: "Agenda una llamada",
    meetingDescription: "Habla con uno de nuestros especialistas",

    hello: "Hola",

    simulation:
      "<strong>Conectado</strong> como <strong>{userName}</strong>. Haz clic en <strong>volver</strong> para regresar a tu cuenta.",

    goTocontrolCTA: "Accede a Conecta Control",
    upsellToControlCTA: "Conoce Conecta Control",
    controlCTADescription: "¡Configura turnos de manera simple y eficiente!",

    dashCards: {
      title: {
        signature: "Firma de correo electrónico",
        vacationMessage: "Mensaje de vacaciones",
        vacationActive: "Vacaciones activas",
        controlShifts: "Turnos de trabajo",
      },
      description: {
        signature: "Tienen firmas de correo electrónico activas",
        vacationMessage: "Tienen mensajes de vacaciones configurados",
        vacationActive: "Están ausentes con vacaciones activas",
        controlShifts: "Están asignados a turnos de trabajo en Control",
      },
      subDescription: {
        signature: "<strong>{usersNumber}</strong> usuarios no tienen",
        controlShifts: "<strong>{usersNumber}</strong> no están en turnos",
      },
      hasToUpgrade: {
        signature: "<strong>¡Crea firmas</strong> que representen tu marca!",
        vacationActive:
          "<strong>¡Gestiona vacaciones</strong> de manera simple y eficiente!",
        controlShifts:
          "<strong>¡Configura turnos</strong> para tus colaboradores!",
      },
    },

    support: "Soporte",
    emptyStateAlert:
      "<strong>Atención:</strong> Los datos que se muestran a continuación son <strong>demostrativos</strong>. Comienza a realizar tareas para <strong>reemplazarlos</strong> con datos reales.",
  },

  guide: {
    guideTitle: "Guía rápida",
    openGuideTip:
      "Para abrir la <strong>Guía rápida</strong> nuevamente, haz clic en tu ícono de perfil y selecciona <strong>Guía rápida</strong>.",

    initOnboarding: {
      title: "¡Empieza a usar Conecta Suite!",
      subtitle:
        "Accede al contenido de onboarding y descubre cómo usar cada herramienta con mayor eficiencia.",
    },

    completedOnboarding: {
      title: "¡Felicidades! Completaste tu Onboarding 🎉",
      subtitle:
        "Para acceder a la guía completa con otras herramientas, haz clic en “Acceder a la guía completa”.",
    },

    completeGuide: {
      title: "Guía completa de la plataforma",
      button: "Acceder a la guía completa",
    },

    stepsOnboarding: {
      buttonLabel: "Iniciar",
      understandOnboardingButton: "Entendido",
      installExtension: {
        title: "Extensión en Google Workspace",
        description:
          "Este es el primer y más importante paso: la instalación de la extensión garantiza el funcionamiento completo de la plataforma.",
        videoTopicsTitle: "Podrás:",
        videoTopics1: "Confirmar que la extensión está correctamente instalada",
        videoTopics2: "Reinstalar o revisar el proceso si es necesario",
      },
      applySignature: {
        title: "Firma de correo electrónico",
        description:
          "¡Aprende en la práctica! Sigue las instrucciones del video y aplica tu firma de correo electrónico de forma rápida y segura.",
        videoTopicsTitle: "Podrás:",
        videoTopics1: "Importar tu propia firma",
        videoTopics2: "Realizar ediciones rápidas",
        videoTopics3: "Aplicar la nueva firma de forma controlada",
      },
      aliasEmail: {
        title: "Alias de correo",
        description:
          "Cree direcciones alternativas que redirigen correos a la misma cuenta de usuario. En el video, aprenderá cómo agregar y gestionar alias de forma simple y segura.",
        videoTopicsTitle: "Podrás:",
        videoTopics1: "Entender qué es un alias de correo",
        videoTopics2: "Visualizar los alias ya configurados",
        videoTopics3: "Agregar un nuevo alias a la cuenta de un usuario",
      },
      secondaryEmail: {
        title: "Correo secundario",
        description:
          "Configure direcciones adicionales que permiten al usuario enviar correos como otro remitente, como un grupo o área. En el video, aprenderá cómo aplicar, editar y eliminar correos secundarios fácilmente.",
        videoTopicsTitle: "Podrás:",
        videoTopics1: "Comprender qué es un correo secundario y cuándo usarlo",
        videoTopics2:
          "Asignar y gestionar correos alternativos o de grupos para un usuario",
        videoTopics3:
          "Asegurar que el usuario pueda enviar mensajes desde la dirección configurada",
      },
      driveSharing: {
        title: "Drives compartidos",
        description:
          "Asigne accesos a los Drives compartidos de la organización de forma centralizada. En el video, aprenderá cómo agregar usuarios y definir el nivel de permiso adecuado.",
        videoTopicsTitle: "Podrás:",
        videoTopics1:
          "Acceder a la configuración de Drives de un usuario específico",
        videoTopics2:
          "Ver todos los Drives compartidos disponibles en la empresa",
        videoTopics3:
          "Agregar al usuario al Drive deseado con el permiso adecuado",
      },
      emailDelegation: {
        title: "Delegación de acceso",
        description:
          "Permita que un colaborador acceda al buzón de otro usuario con seguridad y control. En el video, aprenderá cómo configurar, editar y acceder a los buzones delegados de forma práctica.",
        videoTopicsTitle: "Podrás:",
        videoTopics1:
          "Asignar acceso al buzón de un usuario para otro colaborador",
        videoTopics2:
          "Visualizar delegaciones activas y aplicar configuraciones para mayor seguridad",
        videoTopics3: "Acceder al buzón que fue delegado a ti",
      },
    },

    steps: {
      tags: {
        title: "Cambio de “Etiquetas” a “Información”",
        description: "Ahora, las “TAGs” se llaman “Información”",
        whatChanged: "¿Qué cambió?",
        toBecome:
          "Para hacer la experiencia más intuitiva, el término “Tags” fue reemplazado por “Información” dentro de Conecta Suite.",
        are: "¿Qué es la “Información”?",
        info: "La “Información” son los datos dinámicos del usuario o de la empresa que pueden insertarse automáticamente en las firmas de correo electrónico. Por ejemplo, al agregar [*COMPANY_NAME*] en el editor de firmas, el nombre de la empresa se insertará automáticamente al aplicar la firma.",
        whyChange: "¿Por qué cambiamos el nombre?",
        term: "El término “Tags” generaba dudas entre los usuarios. Con el cambio a “Información”, queremos hacer el uso del recurso más claro y accesible para todos.",
        affects: "¿Este cambio afecta el funcionamiento de la herramienta?",
        same: "No, la funcionalidad sigue siendo la misma. Solo actualizamos el nombre para facilitar la comprensión.",
        support: "Si tienes más dudas, ¡contáctanos por soporte!",
      },
      signApply: {
        title: "Cómo aplicar firmas de correo electrónico",
        description:
          "Ahora, la aplicación de firmas de correo se realiza desde la lista de usuarios",
        menu: "Abre el menú lateral;",
        navigate: "Ve a la opción “Usuarios” y haz clic en ella;",
        useSelection:
          "Usa las casillas de selección para elegir los usuarios a los que deseas aplicar una firma;",
        openApplyMenu:
          "Abre el menú desplegable haciendo clic en “Aplicar para…” y luego selecciona “Firma de correo electrónico”;",
        type: "En la columna izquierda, elige el tipo de plantilla que deseas visualizar;",
        model: "En la columna derecha, haz clic en la plantilla deseada;",
        preview:
          "Previsualiza la firma del colaborador haciendo clic en su nombre;",
        next: "Haz clic en “Siguiente”",
        method: "Selecciona uno de los métodos de aplicación;",
        apply: "Haz clic en “Aplicar plantilla”;",
      },
      insertTags: {
        title: "Cómo insertar “Información” en plantillas",
        description: "Ahora, las “TAGs” se llaman “Información”",
        menu: "Abre el menú lateral;",
        navigate:
          "Ve a la opción “Firmas de correo electrónico” y haz clic en ella;",
        modelType:
          "Selecciona una plantilla personalizada o una plantilla predeterminada en la columna izquierda;",
        editMenu:
          "En la columna derecha, abre el menú desplegable haciendo clic en “Editar”;",
        duplicateEdit:
          "Haz clic en “Duplicar plantilla” o en “Editar plantilla” (si es una personalizada);",
        addInfo:
          "En el menú superior del editor de plantillas, abre el menú desplegable haciendo clic en la última opción “Agregar información”;",
        select:
          "Haz clic en la información deseada (ya sea de “Usuario” o de “Empresa”);",
      },
      batchEditUserTags: {
        title: "Cómo importar “Información” vía CSV",
        description:
          "Ahora, las “TAGs” de usuario se llaman “Información del usuario”",
        menu: "Abre el menú lateral;",
        navigate: "Ve a la opción “Usuarios” y haz clic en ella;",
        dotDotDot:
          "En la segunda barra superior, junto a “+ Crear”, abre el menú desplegable haciendo clic en “...” (tres puntos);",
        csv: "Haz clic en “Actualizar usuarios por CSV”;",
        download:
          "Descarga el archivo CSV haciendo clic en “Descargar información de los usuarios”;",
        edit: "En la aplicación de tu preferencia, edita la información de los usuarios en el CSV descargado;",
        upload: "Sube el archivo CSV haciendo clic en “Adjuntar archivo CSV”;",
        save: "Verifica que la información esté correcta en la tabla de previsualización, y haz clic en “Guardar”.",
      },
      editUserTags: {
        title: "Cómo editar la “Información del usuario”",
        description:
          "Ahora, las “TAGs” de usuario se llaman “Información del usuario”",
        menu: "Abre el menú lateral;",
        navigate: "Ve a la opción “Usuarios” y haz clic en ella;",
        user: "Haz clic en el nombre de un usuario de la lista;",
        openEditMenu:
          "En la columna izquierda, haz clic en la última opción “Editar Información…”;",
        edit: "Edita la información del usuario;",
        save: "Al final de la página, haz clic en “Guardar”;",
        repeat: "Repite el proceso para cada usuario.",
      },
      editCompanyTags: {
        title: "Cómo editar la “Información de la empresa”",
        description:
          "Ahora, las “TAGs” de empresa se llaman “Información de la empresa”",
        menu: "Abre el menú lateral;",
        navigate: "Ve a la opción “Empresa” y haz clic en ella;",
        profile: "Haz clic en la segunda opción: “Perfil”;",
        select:
          "En la columna izquierda, haz clic en el tipo de información que deseas editar;",
        edit: "En la columna derecha, completa o edita la información deseada.",
        save: "Haz clic en “Guardar”.",
      },
    },

    notification: {
      updates: "Notificación de actualización",
      title: "¡Conecta Suite tiene una nueva apariencia!",
      description:
        "La nueva página inicial ahora presenta novedades para ayudarte en la gestión de tus colaboradores.",
    },

    tip: "Para abrir la <strong>Guía rápida</strong> nuevamente, haz clic en tu ícono de perfil y selecciona <strong>Guía rápida</strong>.",
  },

  usersTableMetrics: {
    signature: "Firmas",
    permissions: "Permisos activos",
    vacation: "Mensaje de vacaciones",
    delegates: "Correos delegados",
    vacationControl: "Control de vacaciones",
    shifts: "Turnos",
    signModel: "Plantilla de firma",
    subtitle:
      "Utiliza las pestañas a continuación para ver listas de colaboradores con diferentes configuraciones.",
  },

  permissions: {
    billing: "Facturación",
    inventory: "Inventario digital",
    company_profile: "Perfil de la empresa",
    manage_admins: "Permisos de usuario",
    reseller: "Conecta Partners",
    conecta_control: "Conecta Control",
    conecta_track: "Conecta Track",
    conecta_sign: "Aplicación masiva",
    conecta_suite: "Perfil del usuario",
    sign_automation: "Aplicación automática",
    reports: "Informes",
  },

  groupCreation: {
    intro: {
      subtitle: "Beneficios de utilizar grupos de Google Workspace",
    },
    createGroup: {
      title: "Crear grupo",
      subtitle: "Define el nombre, correo y descripción del grupo.",
    },
    configureAccess: {
      title: "Configurar acceso",
      subtitle: "Define los permisos de acceso de los participantes.",
    },
    addParticipants: {
      title: "Agregar participantes",
      subtitle: "Agrega los usuarios que desees al grupo.",
    },
    configureSharedDrives: {
      title: "Configurar unidades compartidas",
      subtitle: "Agrega y configura las unidades compartidas del grupo.",
    },
  },

  install: {
    app: {
      title: "Activar acceso a @:install.workspace",
      description:
        "<span>Instala <b>Conecta Suite</b> en <b>{provider}</b> y comienza a sincronizar datos y usuarios de tu empresa con nuestra plataforma.</span>",
      action: "Instalar",
      newTab:
        "<span>Se abrió una nueva pestaña, sigue el paso a paso para iniciar sesión con una cuenta de <b>Administrador de Google</b> y luego haz clic en <b>Instalación del Administrador</b> para completar esta etapa.</span>",
      success: "¡Aplicación instalada con éxito!",
      error:
        '<span>Tu verificación falló. Inténtalo nuevamente, o en caso de duda, accede a nuestra <a href="https://conectasuite.com/faq/instalar-conecta-suite" target="_blank" style="text-decoration: none; color: #3498DB !important;">documentación</a>.</span>',
      tryAgain: "Intentar nuevamente",
    },
    documentation: "Documentación de soporte",
    guide: "Guía rápida",
    info: "<span><b>Importante:</b> Se requiere permiso de <b>Administrador</b> de <b>@:install.workspace</b> para configurar el entorno.</span>",
    invite: {
      body: "Hola, estoy usando Conecta Suite como solución para la gestión de usuarios en nuestra organización, pero no tengo los permisos adecuados para configurar el entorno. ¿Podrías ayudarme?",
      copy: "Copiar enlace de invitación",
      email: "Correo electrónico del destinatario",
      subject: "Has sido invitado(a) a Conecta Suite",
      title: "Invitar a tu administrador",
    },
    isNotAdmin: "¿No eres administrador? Invita a tu administrador",
    microsoft: "Microsoft 365",
    sync: {
      title: "Iniciar sincronización",
      info: "<span><b>Sincronizando usuarios:</b> Para realizar algunas tareas, es importante esperar hasta que la sincronización se complete.</span>",
      success: "¡Sincronización completada con éxito!",
    },
    title: "Configuración",
    workspace: "Google Workspace",
    success: {
      linkCopied: "Enlace de invitación copiado al portapapeles.",
      invitationSent: "¡Invitación enviada con éxito!",
    },
    applySignature: {
      title: "Aplicar una firma de correo electrónico",
      description:
        "<span>¡Es hora de poner en práctica Conecta Suite! Sigue las instrucciones del video y aplica una <b>firma de correo</b> de forma <b>rápida</b> y <b>segura.</span>",
      action: "Ir a la aplicación",
    },
  },

  activateMicrosoft: {
    button: {
      label: "Activación de Conecta Suite",
    },
    dialog: {
      title: "Activación de Conecta Suite",
      description:
        "Activar Conecta Suite permite que tu firma de correo sea gestionada por nuestra plataforma, asegurando acceso a todos nuestros recursos.",
      warning:
        "Cada colaborador puede tener solo una firma activa. Para múltiples firmas, desactiva Conecta Suite en la organización. Este cambio puede tardar unos minutos en aplicarse.",
      disable:
        "Si no deseas usar las firmas de correo de Conecta Suite, desactiva esta función.",
      activate:
        "Para aplicar firmas de correo electrónico, debes activar Conecta Suite en tu organización.",
      error: {
        unknown: "Error al activar Conecta Suite",
        notAdmin:
          "No tienes permiso para realizar esta acción. Contacta a tu administrador.",
      },
    },
  },

  understood: {
    cn_9539: {
      title: "Agregar información",
      content:
        'Para agregar información del usuario o de la empresa, haz clic en el menú "Agregar información".',
    },
    cn_9540: {
      title: "Editar información del usuario",
      content:
        'Para editar la información del usuario, haz clic en el ícono de "lápiz".',
    },
    cn_9541: {
      title: "Nombre del modelo",
      content: "El nombre del modelo se puede editar después de su creación.",
    },
    cn_9542: {
      title: "Volver",
      content: 'Para volver a la selección de modelos, haz clic en "Volver".',
    },
    cn_9543: {
      title: "Previsualización",
      content:
        "Para cambiar la posición de la previsualización, haz clic en el selector.",
    },
    cn_9544: {
      title: "Volver",
      content: 'Para volver a la selección de modelos, haz clic en "Volver".',
    },
    cn_9545: {
      title: "Importar CSV",
      content:
        'Para importar un archivo CSV con la información de los usuarios, haz clic en "Importar CSV".',
    },
  },

  verification: {
    notARobot: "Confirma que no eres un robot",
    receiveCode: "Recibe un código de verificación en tu smartphone",
    phoneHint: "Introduce un número de teléfono con DDI, DDD y número",
    weWillVerify: "Verificaremos este número por SMS (puede haber cargos).",
    reloadIn:
      "Ocurrió un problema. La página se recargará en {timer} segundos...",
    resolveCaptcha: "Resuelve el 'Captcha'",
    afterResolving:
      "Después de resolverlo, recibirás un mensaje SMS en tu teléfono.",
    insertCode: "Introduce el código",
    codeSent:
      "Se ha enviado un mensaje SMS a tu número de teléfono con un código de 6 dígitos. Introdúcelo abajo.",
    resendIn: "Podrás enviar un nuevo código en {timer} segundos...",
    expireIn: "El código expirará en {timer} segundos...",
    resendCode: "Reenviar código",
    continueWoCode: "Continuar sin código",
    wentWrong: "Algo salió mal",
    concluded: "Validación completada",
    redirectYou: "Serás redirigido a la aplicación.",
    surveyPhoneVerificationEnd:
      "Envíe el formulario para completar el registro.",
    typeYourPhone: "Escribe un número de teléfono",
    invalidCode: "Código inválido.",
    codeOf6: "El código debe tener 6 dígitos.",
    wasNotPossible:
      "No fue posible enviar el código de verificación. Intenta nuevamente.",
    tooManyRequests:
      "Has realizado demasiados intentos. Por favor, espera un momento antes de intentar nuevamente.",
    unknownError: "Error desconocido. Por favor, intenta nuevamente.",
    codeExpired: "Código expirado. Intenta enviarlo otra vez.",
  },

  onboarding: {
    steps: {
      personal_data: "Datos personales",
      company: "Empresa",
      preferences: "Preferencias",
      verification: "Verificación",
    },
    title: "Completa tu registro",
    subtitle: "Rellena los datos solicitados a continuación",
    form: {
      full_name: {
        label: "Nombre completo",
        placeholder: "Introduce tu nombre completo",
      },
      whatsapp_number: {
        label: "Número de WhatsApp",
        placeholder: "Introduce tu número de WhatsApp",
      },
      position: {
        label: "¿Cuál es tu cargo actual?",
        options: {
          analyst_assistant: "Analista / Asistente",
          coordinator_supervisor: "Coordinador(a) / Supervisor(a)",
          dev_devops_infra: "Dev / DevOps / Infra",
          director_manager: "Director(a) / Gerente",
          intern: "Practicante",
          student: "Estudiante",
          other_positions: "Otros cargos",
          partner_ceo_owner: "Socio(a) / CEO / Propietario(a)",
          it_third_party: "Tercerizado de TI",
        },
      },
      sector: {
        label: "¿En qué área de la empresa trabaja?",
        options: {
          marketing: "Marketing",
          sales: "Ventas",
          hr: "RRHH",
          it: "TI",
          design: "Diseño",
          programming: "Programación",
          legal: "Legal",
          management: "Gestión",
          externalConsultant: "Consultor externo",
          others: "Otro",
        },
      },
      find_out: {
        label: "¿Cómo conociste Conecta Suite?",
        options: {
          google_search: "Búsqueda en Google",
          facebook: "Facebook",
          instagram: "Instagram",
          linkedin: "LinkedIn",
          youtube: "YouTube",
          recommended: "Me lo recomendaron",
          others: "Otro",
        },
      },
      point_system: {
        label: "¿Utilizas algún sistema de control de horario?",
        options: {
          adp: "ADP",
          sap: "SAP",
          omie: "Omie",
          nomus: "Nomus",
          sankhya: "Sankhya",
          vrGente: "VR Gente",
          bambooHR: "BambooHR",
          totvs: "Totvs",
          webmail: "Webmail",
          workdayHCM: "Workday HCM",
          seniorSistemas: "Senior Sistemas",
          solidesTangerino: "Solides Tangerino",
          apdataGlobalAntares: "Apdata Global Antares",
          others: "Otro",
          no: "No",
        },
      },
      employees_number: {
        label: "¿Cuántos empleados tiene tu empresa?",
        options: {
          from_1_to_5: "1-5",
          from_6_to_15: "6-15",
          from_16_to_50: "16-50",
          from_51_to_100: "51-100",
          from_101_to_300: "101-300",
          from_301_to_1000: "301-1000",
          above_1000: "más de 1000 colaboradores",
        },
      },
      company_sector: {
        label: "¿En qué sector opera tu empresa?",
        options: {
          accounting: "Contabilidad",
          airlines_aviation: "Aerolíneas / Aviación",
          alternative_dispute_resolution:
            "Resolución alternativa de conflictos",
          alternative_medicine: "Medicina alternativa",
          animation: "Animación",
          apparel_fashion: "Ropa y moda",
          architecture_planning: "Arquitectura y planificación",
          arts_and_crafts: "Artesanía",
          automotive: "Automotriz",
          aviation_aerospace: "Aviación y aeroespacial",
          banking: "Bancos",
          biotechnology: "Biotecnología",
          broadcast_media: "Medios de difusión",
          building_materials: "Materiales de construcción",
          business_supplies_and_equipment:
            "Suministros y equipos empresariales",
          capital_markets: "Mercados de capital",
          chemicals: "Químicos",
          civic_social_organization: "Organización cívica y social",
          civil_engineering: "Ingeniería civil",
          commercial_real_estate: "Bienes raíces comerciales",
          computer_network_security: "Seguridad de redes informáticas",
          computer_games: "Juegos de computadora",
          computer_hardware: "Hardware de computadora",
          computer_networking: "Redes de computadoras",
          computer_software: "Software de computadora",
          internet: "Internet",
          construction: "Construcción",
          consumer_electronics: "Electrónica de consumo",
          consumer_goods: "Bienes de consumo",
          consumer_services: "Servicios al consumidor",
          cosmetics: "Cosméticos",
          dairy: "Lácteos",
          defense_space: "Defensa y espacio",
          design: "Diseño",
          education_management: "Gestión educativa",
          e_learning: "E-learning",
          electrical_electronic_manufacturing:
            "Fabricación eléctrica/electrónica",
          entertainment: "Entretenimiento",
          environmental_services: "Servicios ambientales",
          events_services: "Servicios de eventos",
          executive_office: "Oficina ejecutiva",
          facilities_services: "Servicios de instalaciones",
          farming: "Agricultura",
          financial_services: "Servicios financieros",
          fine_art: "Bellas artes",
          fishery: "Pesca",
          food_beverages: "Alimentos y bebidas",
          food_production: "Producción de alimentos",
          fund_raising: "Recaudación de fondos",
          furniture: "Muebles",
          gambling_casinos: "Juegos y casinos",
          glass_ceramics_concrete: "Vidrio, cerámica y concreto",
          government_administration: "Administración pública",
          government_relations: "Relaciones gubernamentales",
          graphic_design: "Diseño gráfico",
          health_wellness_and_fitness: "Salud, bienestar y fitness",
          higher_education: "Educación superior",
          hospital_health_care: "Hospital y atención médica",
          hospitality: "Hostelería",
          human_resources: "Recursos humanos",
          import_and_export: "Importación y exportación",
          individual_family_services: "Servicios individuales y familiares",
          industrial_automation: "Automatización industrial",
          information_services: "Servicios de información",
          information_technology_and_services:
            "Tecnología de la información y servicios",
          insurance: "Seguros",
          international_affairs: "Asuntos internacionales",
          international_trade_and_development:
            "Comercio y desarrollo internacional",
          investment_banking: "Banca de inversión",
          investment_management: "Gestión de inversiones",
          judiciary: "Judicatura",
          law_enforcement: "Cumplimiento de la ley",
          law_practice: "Práctica legal",
          legal_services: "Servicios legales",
          legislative_office: "Oficina legislativa",
          leisure_travel_tourism: "Ocio, viajes y turismo",
          libraries: "Bibliotecas",
          logistics_and_supply_chain: "Logística y cadena de suministro",
          luxury_goods_jewelry: "Bienes de lujo y joyería",
          machinery: "Maquinaria",
          management_consulting: "Consultoría de gestión",
          maritime: "Marítimo",
          market_research: "Investigación de mercado",
          marketing_and_advertising: "Marketing y publicidad",
          mechanical_or_industrial_engineering:
            "Ingeniería mecánica o industrial",
          media_production: "Producción de medios",
          medical_devices: "Dispositivos médicos",
          medical_practice: "Práctica médica",
          mental_health_care: "Atención de salud mental",
          military: "Militar",
          mining_metals: "Minería y metales",
          motion_pictures_and_film: "Películas y cine",
          museums_and_institutions: "Museos e instituciones",
          music: "Música",
          nanotechnology: "Nanotecnología",
          newspapers: "Periódicos",
          non_profit_organization_management: "Gestión de ONG",
          oil_energy: "Petróleo y energía",
          online_media: "Medios en línea",
          outsourcing_offshoring: "Externalización/Offshoring",
          package_freight_delivery: "Entrega de paquetes/fretes",
          packaging_and_containers: "Envases y contenedores",
          paper_forest_products: "Productos de papel y forestales",
          performing_arts: "Artes escénicas",
          pharmaceuticals: "Farmacéutica",
          philanthropy: "Filantropía",
          photography: "Fotografía",
          plastics: "Plásticos",
          political_organization: "Organización política",
          primary_secondary_education: "Educación básica/secundaria",
          printing: "Impresión",
          professional_training_coaching: "Formación profesional y coaching",
          program_development: "Desarrollo de programas",
          public_policy: "Política pública",
          public_relations_and_communications:
            "Relaciones públicas y comunicaciones",
          public_safety: "Seguridad pública",
          publishing: "Publicación",
          railroad_manufacture: "Fabricación ferroviaria",
          ranching: "Ganadería",
          real_estate: "Bienes raíces",
          recreational_facilities_and_services:
            "Instalaciones y servicios recreativos",
          religious_institutions: "Instituciones religiosas",
          renewables_environment: "Renovables y medio ambiente",
          research: "Investigación",
          restaurants: "Restaurantes",
          retail: "Venta al por menor",
          security_and_investigations: "Seguridad e investigaciones",
          semiconductors: "Semiconductores",
          shipbuilding: "Construcción naval",
          sporting_goods: "Artículos deportivos",
          sports: "Deportes",
          staffing_and_recruiting: "Contratación y selección",
          supermarkets: "Supermercados",
          telecommunications: "Telecomunicaciones",
          textiles: "Textiles",
          think_tanks: "Think tanks",
          tobacco: "Tabaco",
          translation_and_localization: "Traducción y localización",
          transportation_trucking_railroad: "Transporte/camiones/ferrocarril",
          utilities: "Servicios públicos",
          venture_capital_private_equity: "Capital de riesgo y capital privado",
          veterinary: "Veterinaria",
          warehousing: "Almacenamiento",
          wholesale: "Venta al por mayor",
          wine_and_spirits: "Vinos y licores",
          wireless: "Inalámbrico",
          writing_and_editing: "Redacción y edición",
          mobile_games: "Juegos móviles",
        },
      },
      interest_areas: {
        label: "Áreas de interés",
        subtitle:
          "Puedes seleccionar hasta 4 ítems, pero no te preocupes, podrás acceder a los demás más adelante.",
        placeholder: "Selecciona hasta 4 ítems",
        options: {
          email_signature: "Firma de correo",
          vacation_message: "Mensaje de vacaciones",
          access_permissions: "Permisos de acceso",
          email_delegation: "Delegación de correos",
          shift_control: "Control de turnos",
          vacation_control: "Control de vacaciones",
          email_migration: "Migración de correos",
          shared_drive: "Compartición de unidades",
          secondary_emails: "Correos secundarios",
          email_aliases: "Alias de correo",
          group_management: "Gestión de grupos",
        },
      },
      verification_number: {
        label: "Ingrese un número de celular válido",
        subtitle:
          "Este número se utilizará para contactos importantes, como recuperación de cuenta o confirmación de identidad.",
      },
    },
  },

  contactUs: {
    title: "¿En qué podemos ayudarte?",
    faq: {
      title: "Preguntas frecuentes",
      viewAll: "Ver todos los artículos de ayuda",
      notFound: {
        title: "¿No encontraste lo que buscabas?",
        description: "Ponte en contacto con nuestro equipo de soporte,",
      },
    },
    cards: {
      schedule: {
        title: "Agenda una conversación",
        subtitle:
          "Habla con nuestros especialistas y resuelve todas tus dudas.",
        action: "Agendar",
      },
      whatsapp: {
        title: "Atención por WhatsApp",
        subtitle:
          "Habla con nuestros especialistas y resuelve todas tus dudas.",
        action: "Conversar",
      },
      support: {
        title: "Soporte",
        subtitle: "Estamos aquí para ayudarte con lo que necesites.",
        action: "Abrir",
      },
      commercial: {
        title: "Chat en vivo",
        subtitle: "Habla directamente con nuestros representantes.",
        action: "Hablar",
      },
      overview: {
        title: "Visión general",
        subtitle: "Una visión general de las funcionalidades de Conecta Suite.",
        action: "Abrir",
      },
      feedback: {
        title: "Comentarios",
        subtitle: "Envía tu opinión directamente a nuestros desarrolladores.",
        action: "Enviar",
      },
    },
  },

  htmlEditor: {
    imageMenu: {
      option: "Propiedades de la imagen",
      dialog: "Insertar/editar imagen",
      tab: {
        general: "General",
        advanced: "Avanzado",
      },
      border: {
        none: "Ninguno",
        rounded: "Borde redondeado",
        circle: "Borde circular",
        square: "Borde cuadrado",
      },
      sourceTooltip:
        "Sube la imagen a tu Drive corporativo, copia el enlace con acceso público y pégalo aquí.",
      stylePlaceholder: "*Edita los campos abajo*",
      input: {
        source: "Origen",
        alt: "Descripción alternativa",
        sizes: "Dimensiones",
        borders: "Bordes",
        style: "Estilo",
        verticalMargin: "Espacio vertical",
        horizontalMargin: "Espacio horizontal",
        borderWidth: "Grosor del borde",
        borderStyle: "Estilo del borde",
      },
      borderStyle: {
        select: "Seleccionar...",
        solid: "Sólido",
        dotted: "Punteado",
        dashed: "Rayado",
        double: "Doble",
        groove: "Estriado",
        ridge: "En relieve",
        inset: "Relieve hundido",
        outset: "Relieve elevado",
        none: "Ninguno(a)",
        hidden: "Oculto",
      },
    },
  },

  migrationToGroupAlert: {
    title: "¿Acabas de crear el grupo de correo?",
    description:
      "Puede tardar hasta <b>24h</b> para que Google procese la creación. Durante este período, la <b>migración puede no funcionar</b> correctamente. Recomendamos esperar antes de intentarlo nuevamente.",
  },

  migrationHistory: {
    migrationHistoryTitle: "Historial de migraciones",
    createMigrationProjectLabel: "Crear migraciones",
    syncLabel: "@:action.sync",

    createdAtHeader: "Fecha de registro",
    descriptionHeader: "Descripción",
    sharedWithHeader: "Compartido con",
    authorHeader: "Ator",
    tooltipAuthor: "El usuario que ejecutó el evento",
    eventHeader: "Evento",
    progressHeader: "Progreso",
    statusHeader: "Estado",
    actionsHeader: "@:common.actions",

    optionCancel: "@:action.cancel",
    optionInterrupt: "@:action.interrupt",

    IN_PROGRESS: "En progreso",
    INTERRUPTED: "@:common.interrupted",
    CANCELED: "@:common.canceled",
    COMPLETED: "Completado",
    COMPLETED_WITH_ERRORS: "Completado con errores",
    FAILED: "Fallido",
    IN_QUEUE: "En cola",
    IN_QUEUE_TOOLTIP: "Esperando procesamiento",

    ADD_TO_GROUP: "Agregar al grupo",
    add_to_group_description:
      "Agregar el usuario '{source_user}' al grupo de correo '{destination_group}'",
    DRIVE: "Transferir archivos",
    drive_description:
      "Transferir archivos del usuario '{source_user}' al grupo de correo '{destination_group}'",
    EMAIL_TO_GROUP: "Migrar correos",
    migration_description:
      "Migración de correos del usuario '{source_user}' al grupo '{destination_group}'",
    REMOVE_LICENSE: "Eliminar licencia",
    remove_license_description:
      "Eliminar licencias del usuario '{source_user}'",

    loadingTableText: "Cargando historial de migraciones...",
    noDataTableText: "No se encontró historial de migraciones",
    migrationInProgress:
      "Ya hay una migración en curso. Espere a que finalice para iniciar una nueva.",
  },

  migrationCreationIntro: {
    title: "Migra datos de forma sencilla, segura y escalable",
    subheader: "Antes de comenzar, debes saber",
    totalSteps: "La configuración se realiza en solo 2 pasos.",
    preserveImportantDataMessage:
      "Evita la pérdida de datos al desactivar cuentas: transfiere correos y archivos a un grupo para mantener la información accesible.",
    csvStepDescription:
      "Usa un archivo CSV para migrar datos de varios usuarios a la vez, con mayor agilidad y control.",
    migrationEmailSizeLimitMessage:
      "Los mensajes de correo electrónico de más de 25 MB no se migrarán con el sistema de Google.",
    learnMoreText: "Más información.",
    learnMoreUrl:
      "https://developers.google.com/workspace/admin/data-transfer/v1/limits?hl=es-419",
    migrationTimeDescription:
      "El proceso de migración puede tardar hasta 1 hora en comenzar después de la confirmación.",
    suportHelperLabel:
      "Si tienes dudas, puedes contactar a nuestro soporte por los canales de atención.",
  },

  migrationCreationCSV: {
    step1: "Descarga la plantilla de configuración CSV",
    step1ProgressBar: "Introducciónn",
    buttonDownload: "Descargar plantilla",
    fileName: "Configuración de migración",
    step2: "Completa el archivo con los datos de la migración",
    trialAlert:
      "La versión gratuita permite hasta 2 migraciones con un período máximo de 3 meses. Para continuar, es necesario contratar un plan desde Security.",

    instructionStep2Title: "Cómo completar el archivo de migración",
    instructionStep2RequiredFields:
      "'Correo electrónico de origen' y 'Grupo de destino' son campos obligatorios.",
    instructionStep2RemoveUnusedRows:
      "El archivo viene prellenado con todos los usuarios; elimine las filas de aquellos que no tendrán datos migrados.",
    instructionStep2SharedWithField:
      "En 'Compartidos', agregue las direcciones de correo electrónico de los usuarios a los que desee garantizar el acceso a los correos migrados. Separe las direcciones de correo electrónico con espacios (sin comas).",
    instructionStep2DateField:
      "Ingrese la fecha en formato día/mes/año, que no puede ser posterior a la fecha actual; si el campo queda en blanco, se considerará automáticamente el último año como período de migración",
    instructionStep2DateFieldTrial:
      "Ingrese la fecha en el formato día/mes/año. La fecha no puede ser posterior a la actual. Si el campo queda en blanco, se considerarán automáticamente los últimos 3 meses como período de migración.",

    uploadTooltipError:
      "No se pudo validar el archivo. Vuelve a subir el CSV completo.",
    uploadTooltipEmpty: "Sube un archivo CSV completo para continuar.",
    uploadTooltipReady: "Listo para revisar los datos enviados.",

    snackbarUploadSuccess:
      "El archivo se procesó correctamente. Avance para revisar los datos antes de iniciar la migración.",
    snackbarUploadError:
      "No se pudo procesar el archivo. Descargue la plantilla, mantenga el encabezado original, complete los campos obligatorios y envíe nuevamente.",

    step2ProgressBar: "Importar usuarios vía CSV",
    step3: "Importar el CSV completo",
    step3ProgressBar: "Validar",
    buttonUpload: "Importar CSV de migración",
    exampleSourceEmail: "origen@mail.com",
    exampleTargetEmail: "grupo@mail.com",
    exampleTargetDriveEmail: "drive@mail.com",
    exampleSharedWith:
      "usuarios.adicionales@mail.com usuarios.adicionales@mail.com",
    examplePeriod: "Día/Mes/Año",
  },

  migrationValidation: {
    alertMigrationValidation:
      "Se encontraron errores en el archivo enviado. Para corregirlos, regrese al paso anterior, ajuste el CSV y envíe un nuevo archivo actualizado.",
    alertWarningMigrationValidation:
      "La migración puede iniciarse, pero el archivo contiene alertas. Revise los mensajes y, si es necesario, retroceda un paso para enviar un CSV corregido.",
    buttonNewCsv: "Enviar nuevo CSV",
    headerSourceEmail: "Correo electrónico de origen",
    headerTargetEmail: "Grupo de destino",
    headerTargetDrive: "Drive de destino",
    headerSharedWith: "Compartidos",
    headerStartDate: "Fecha de inicio",
  },

  migrationTooltipMessage: {
    sharedWith:
      "Usuarios que necesitan acceso a los correos migrados. Si no son miembros del grupo de destino, serán añadidos automáticamente.",
    period:
      "Fecha de inicio de los correos que se migrarán. La migración incluye automáticamente los mensajes hasta la fecha actual.",
    confirmButtonTooltipWithErrors:
      "Hay campos con errores. Corrígelos para continuar.",
    confirmButtonTooltipWithoutErrors: "Avanza para confirmar las migraciones.",
    ADD_TO_GROUP:
      "El usuario de origen aún no forma parte del grupo de destino. Será añadido automáticamente.",
    DEFAULT_VALUE:
      "No se encontró una fecha de inicio. Se considerará el último año como el período de migración.",
    INVALID_DATE_FORMAT:
      "La fecha proporcionada tiene un formato no válido. Utilice el formato día/mes/año.",
    INVALID_DATE_GREATER_THAN_TODAY:
      "La fecha de inicio no puede ser posterior a la fecha actual. Ajústela a un día anterior o igual a hoy.",
    NEED_CREATE:
      "No se encontró esta dirección de correo electrónico. Se creará un nuevo grupo con la dirección proporcionada.",
    NEW_DRIVE:
      "Se creará un nuevo drive con un nombre generado automáticamente.",
    NO_LICENSE:
      "Este correo electrónico no tiene una licencia de buzón. Active una en el panel de Google Workspace para migrar el correo.",
    NOT_FOUND:
      "Este correo electrónico no fue encontrado. Verifique que la dirección sea correcta y que corresponda a un {type} válido.",
    USER_DUPLICATED:
      "Este correo electrónico está duplicado. Elimine una de las líneas para continuar.",
    REQUIRED_FIELD: "Este campo es obligatorio. Complétalo para continuar.",
    INVALID_EMAIL_FORMAT:
      "El correo electrónico ingresado tiene un formato no válido. Corrige la dirección para continuar.",
    TRIAL_LIMIT_EXCEEDED:
      "Se alcanzó el límite de migraciones permitidas durante el período de prueba. Esta migración no se ejecutará.",
    TRIAL_PERIOD_LIMIT:
      "Durante el período de prueba, solo se pueden migrar datos de los últimos 3 meses.",
  },

  migrationLabel: {
    user: "usuario",
    group: "grupo",
  },

  confirmMigrationModal: {
    confirmMigrationTitle: "¿Confirmar inicio de las migraciones?",
    informationConfirmMigration:
      "Después de la confirmación, el proceso puede tardar hasta 1 hora en comenzar. Espere antes de revisar los detalles. La duración total dependerá de la cantidad de datos procesados.",
    migrationUserDeletionWarning:
      "No elimine usuarios durante la migración. Eliminar puede causar errores y pérdida de datos. Espere a que finalice el proceso.",
    confirmMigrationButton: "Confirmar",
    cancelMigrationButton: "Cancelar",
    successSnack:
      "Migraciones iniciadas con éxito. Siga el progreso en el historial.",
    errorSnack:
      "No fue posible iniciar las migraciones. Inténtelo de nuevo o verifique la configuración.",
  },
  cancelMigrationDialog: {
    titleCancel: "¿Desea cancelar la migración?",
    titleInterrupt: "¿Desea interrumpir la migración en curso?",
    infoCancel:
      "La migración será cancelada y eliminada de la cola de ejecución.",
    infoInterrupt:
      "La migración será interrumpida. Este proceso puede tardar algunos minutos en completarse.",
    warning:
      "Esta acción no se puede deshacer. Para migrar los datos nuevamente, será necesario crear un nuevo proceso.",
    confirm: "@:action.confirm",
    cancel: "@:action.cancel",
    successfullyCanceled: "Migración cancelada.",
    successfullyInterrupted:
      "Interrupción de la migración en curso. Esto puede tardar algunos minutos.",
    cancelFailed:
      "No se pudo cancelar la migración. El registro puede estar inconsistente.",
  },

  supportDialog: {
    title: "Contacta a equipo de soporte",
    message:
      'Para solicitar soporte, ponte en contacto directamente con el equipo de <span class="font-weight-bold">{name}</span>.',
  },

  licenseLimiterSettings: {
    notifyUsersTitle: "Usuarios notificados",
    notifyUsersDescription:
      "Administradores que recibirán notificaciones sobre el uso de la licencia.",

    automaticActionTitle: "Acciones automáticas",
    automaticActionDescription:
      "Defina cómo debe actuar el sistema de gestión cuando un dominio exceda el límite de licencias.",

    removeLicense: "Eliminar licencia",
    removeLicenseTooltip:
      "Elimina automáticamente licencias de usuarios excedentes. Se considerarán para eliminación los usuarios más recientes que no sean administradores.",

    suspendUser: "Suspender usuario",
  },
};
